<template>
  <div class="project project--epos">
    <!-- programeaza o intalnire cta -->
    <div class="appointment-cta">
      <a
        href="#"
        @click.prevent="AppointmentForm(true)"
        @keydown.esc="AppointmentForm(false)"
        >{{ strings.programeaza_intalnire_cta }}
      </a>
    </div>

    <!-- programeaza o intalnire form -->
    <div class="appointment-form">
      <div class="appointment-form-shape mask-right">
        <div class="appointment-form-col">
          <a href="#" @click.prevent="AppointmentForm(false)">
            <svg
              width="47"
              height="44"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke="#000"
                stroke-width="2"
                d="M2.6976 1.2835l43.0645 41.9334M44.3669 1.2835L1.3024 43.217"
              />
            </svg>
          </a>
        </div>
        <div class="appointment-form-col">
          <h5>{{ strings.programeaza_intalnire_headline }}</h5>
          <form
            class="form-styles form-styles--dark form-styles--w70"
            @submit="submitForm"
            action="#"
            method="post"
          >
            <input
              type="hidden"
              id="form_type"
              name="form_type"
              value="meeting"
            />
            <input
              type="text"
              name="user_name"
              v-model="user_name"
              value=""
              :placeholder="strings.programeaza_intalnire_nume"
              required
            />
            <input
              type="email"
              name="user_email"
              v-model="user_email"
              value=""
              :placeholder="strings.programeaza_intalnire_email"
              required
            />
            <input
              type="tel"
              name="user_phone"
              pattern="[0-9]{4}[0-9]{3}[0-9]{3}"
              v-model="user_phone"
              value=""
              :placeholder="strings.programeaza_intalnire_tel"
              required
            />
            <input
              type="date"
              id="date"
              name="user_date"
              v-model="user_date"
              value=""
              min="2020-06-01"
              max="2030-12-31"
            />
            <textarea
              name="user_message"
              rows="8"
              cols="80"
              v-model="user_message"
              :placeholder="strings.programeaza_intalnire_mesaj"
              required
            ></textarea>
            <!-- newsletter -->
            <div class="gdpr_wrapper gdpr_wrapper--black">
              <input
                type="checkbox"
                id="subscribe_newsletter"
                name="subscribe_newsletter"
                value="true"
              />
              <span class="checkmark"></span>
              <label
                class="label_subscribe_newsletter"
                for="subscribe_newsletter"
                >{{ strings.subscribe_newsletter }}</label
              >
            </div>

            <!-- t&c -->
            <div class="gdpr_wrapper gdpr_wrapper--black">
              <input
                type="checkbox"
                id="accept_tc_1"
                name="accept_tc_1"
                value="Accept T&C"
                required
              />
              <span class="checkmark"></span>
              <label class="label_accept_tc_1" for="accept_tc_1">{{
                strings.programeaza_intalnire_accept_termeni
              }}</label>
            </div>
            <input
              type="submit"
              :value="strings.programeaza_intalnire_accept_trimite"
            />
          </form>
          <h6>{{ strings.programeaza_intalnire_thanks }}</h6>
        </div>
      </div>
    </div>

    <!-- formular brosura -->
    <div class="download-form">
      <div class="download-form-shape mask-left">
        <div class="download-form-col">
          <a href="#" @click.prevent="DownloadForm(false)">
            <svg
              width="47"
              height="44"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke="#000"
                stroke-width="2"
                d="M2.6976 1.2835l43.0645 41.9334M44.3669 1.2835L1.3024 43.217"
              />
            </svg>
          </a>
        </div>
        <div class="download-form-col">
          <h5>
            {{ strings.brosura_headline }}
          </h5>
          <form
            class="form-styles form-styles--dark form-styles--w70"
            @submit="submitForm"
            action="#"
            method="post"
          >
            <input
              type="hidden"
              id="form_type"
              name="form_type"
              value="brochure"
            />
            <input
              type="text"
              name="user_name"
              id="user_name"
              v-model="user_name"
              value=""
              :placeholder="strings.programeaza_intalnire_nume"
              required
            />
            <input
              type="email"
              name="user_email"
              id="user_email"
              v-model="user_email"
              value=""
              :placeholder="strings.programeaza_intalnire_email"
              required
            />
            <input
              type="tel"
              name="user_phone"
              pattern="[0-9]{4}[0-9]{3}[0-9]{3}"
              id="user_phone"
              v-model="user_phone"
              value=""
              :placeholder="strings.programeaza_intalnire_tel"
              required
            />

            <div class="gdpr_wrapper gdpr_wrapper--black">
              <input
                type="checkbox"
                id="label_accept_tc_3"
                name="label_accept_tc_3"
                value="Accept T&C"
                required
              />
              <span class="checkmark"></span>
              <label class="label_accept_tc_1" for="label_accept_tc_3">{{
                strings.programeaza_intalnire_accept_termeni
              }}</label>
            </div>
            <input type="submit" :value="strings.descarca" />
          </form>
        </div>
      </div>
    </div>

    <!-- Hero module -->
    <div
      id="hero"
      class="project-hero mask-right"
      v-if="content.mediaFiles"
      :style="{
        backgroundImage: 'url(' + content.mediaFiles.image_top_mobile + ')'
      }"
    >
      <div class="home-hero-content">
        <!-- mobile: play video -->
        <div class="mobile-video" v-if="isMobile">
          <video class="fullscreen-video">
            <source :src="content.mediaFiles.top_cover" type="video/mp4" />
          </video>
        </div>

        <!-- desktop video -->
        <video autoplay muted loop v-if="!isMobile">
          <source :src="content.mediaFiles.top_cover" type="video/mp4" />
        </video>
        <!-- -->
        <div class="video-controls" data-playing="false" v-if="isMobile">
          <!-- pause -->
          <!-- <a href="#" class="pause" @click.prevent="toggleVideo(false)">
            <svg
              width="31"
              height="31"
              fill="#fff"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="15.5"
                cy="15.5"
                r="15.155"
                stroke="#fff"
                stroke-width=".69"
              />
              <path
                stroke="#000"
                stroke-width=".69"
                d="M12.345 11v10M19.345 11v10"
              />
            </svg>
          </a> -->

          <!-- play btn -->
          <!-- <a href="#" class="play" @click.prevent="toggleVideo(true)">
            <svg
              width="31"
              height="31"
              fill="#fff"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="15.5"
                cy="15.5"
                r="15.155"
                stroke="#fff"
                stroke-width=".69"
              />
              <path
                d="M21 15.7273L12 10v10.6364l9-4.9091z"
                stroke="#000"
                stroke-width=".5871"
              />
            </svg>
          </a> -->
        </div>
        <div class="home-hero-content-wrapper content"></div>
      </div>
    </div>

    <!-- Section: details -->
    <div class="section-wrapper section-wrapper--projectdetails">
      <svg class="epos-logo" width="112" height="112" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="56" cy="56" r="56" fill="#F9AF41"/><path d="M67.814 39.97H49.358v18.456h18.456V39.97Z" fill="#F9DF41" stroke="#000" stroke-width="1.476"/><path d="M64.122 43.66H49.358v11.074h14.764V43.66Z" fill="#A5BDC6" stroke="#000" stroke-width="1.476"/><path d="M100.295 39.97 67.813 27.42v31.005h32.482V39.97Z" fill="#F9DF41" stroke="#000" stroke-width="1.476"/><path d="M94.39 58.425H49.358v25.838H94.39V58.425Z" fill="#E0E0E2" stroke="#000" stroke-width="1.476"/><path d="M90.698 63.593v20.67H64.122v-20.67h26.576Z" fill="#A5BDC6" stroke="#000" stroke-width="1.476"/><path d="M84.055 63.593V85M77.41 63.593V85m-7.383-21.408V85m-20.67-21.408h9.597V76.88h-9.597" stroke="#000" stroke-width="1.476"/><path d="M95.128 54.734V43.66H72.243v11.074h22.884Z" fill="#A5BDC6"/><path d="M87.007 43.66h8.12v11.074h-8.12m0-11.074v11.074m0-11.074h-7.382m7.382 11.074h-7.382m0-11.074h-7.382v11.074h7.382m0-11.074v11.074M48.619 84.263h51.676" stroke="#000" stroke-width="1.476"/><mask id="a" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="21" width="51" height="65"><path fill="#C4C4C4" d="M.634 21.513h50.2v63.488H.634z"/></mask><g mask="url(#a)"><path d="m6.02 54.516 35.747-30.82 35.537 30.82" stroke="#000" stroke-width="1.426" stroke-linecap="round"/><path d="M14.929 53.573v30.715h53.253V53.573L41.555 31.244 14.93 53.573Z" fill="#F9AF41"/><path d="M16.92 43.824v-12.58h6.71v7.548m-8.701 45.496V53.573l26.626-22.329 26.627 22.329v30.715H47.95h1.85-34.87Z" stroke="#000" stroke-width="1.426" stroke-linecap="round"/><path fill="#F9AF41" stroke="#000" stroke-width="1.426" d="M33.821 64.328h14.257v19.96H33.821z"/><path d="M50.096 20.775v63.488" stroke="#000" stroke-width="5.068"/></g><circle cx="49.618" cy="54.102" r="11.824" fill="#000"/><path d="m47.758 46.606-.038 15.948-7.955-7.992 7.993-7.956Z" fill="#F9AF41"/><path d="m51.48 46.606.037 15.948 7.955-7.992-7.992-7.956Z" fill="#F9DF41"/>
      </svg>

      <div class="project-details-shadow our-projects-shadow mask-left active">
        <h2>{{ content.name }}</h2>
      </div>

      <!-- Project details -->
      <div
        class="project-details our-projects project-details-mask mask-right active"
      >
        <!-- list -->
        <div class="project-details-wrapper our-projects-wrapper">
          <!-- project block -->
          <div class="project-details-block our-projects-block">
            <!-- title -->
            <div class="project-details-block-title">
              <h5>{{ content.year }}</h5>
              <span class="v-spacer"></span>
              <h5>{{ content.address }}</h5>
              <span class="v-spacer"></span>
              <h5>{{ content.status }}</h5>
            </div>
          </div>

          <!-- project block -->
          <div
            class="project-details-block project-details-block--row our-projects-block"
          >
            <!-- item -->
            <div class="project-details-block-item">
              <svg width="133" height="102" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="125.765" height="45.155" rx="22.491" transform="matrix(.99289 .11906 -.16479 .98633 7.441 21)" fill="#F9AF41"/><path stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M16 1h100v100H16z"/><path stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M26 11h80v80H26z"/><path d="m34.361 18 2.989 11.153 8.165-8.165L34.361 18Zm66 66-2.988-11.154-8.165 8.165L100.36 84ZM40.018 25.07 93.29 78.344l1.415-1.414-53.273-53.272-1.414 1.414Z" fill="#000"/>
              </svg>
              <h6>
                <number
                  :class="{ scaleBig: scaleClass }"
                  ref="number1"
                  :from="0"
                  animationPaused
                  :to="content.amenities.apartments"
                  :duration="duration"
                  easing="Power1.easeOut"
                  v-observe-visibility="{
                    callback: (isVisible, entry) =>
                      visibilityChanged(isVisible, entry, 'numbers'),
                    intersection: {
                      threshold: 0.3
                    }
                  }"
                />
                m² <span>{{ strings.suprafata_utila }}</span>
              </h6>
            </div>
            <!-- item -->
            <div class="project-details-block-item">
              <svg width="133" height="102" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="125.765" height="45.155" rx="22.491" transform="matrix(.99289 .11906 -.16479 .98633 7.441 21)" fill="#F9AF41"/><path stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M16 1h100v100H16z"/><path d="m25.167 10.167 3.17 11.103 8.03-8.298-11.2-2.805Zm84.389 81.666-3.171-11.103-8.03 8.298 11.201 2.805ZM30.939 17.144l71.454 69.15 1.391-1.438-71.454-69.15-1.391 1.438Z" fill="#000"/>
              </svg>
              <h6>
                <number
                  :class="{ scaleBig: scaleClass }"
                  ref="number2"
                  :from="0"
                  animationPaused
                  :to="content.amenities.basement_box"
                  :duration="duration"
                  easing="Power1.easeOut"
                  v-observe-visibility="{
                    callback: (isVisible, entry) =>
                      visibilityChanged(isVisible, entry, 'numbers'),
                    intersection: {
                      threshold: 0.3
                    }
                  }"
                />
                m² <span>{{ strings.suprafata_totala }}</span>
              </h6>
            </div>
            <!-- item -->
            <div class="project-details-block-item">
              <svg width="133" height="103" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="125.765" height="45.155" rx="22.491" transform="matrix(.99289 .11906 -.16479 .98633 7.441 22)" fill="#F9AF41"/><path stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M15.5 1.729h100.27v100.27H15.5z"/><path d="M48 101a1 1 0 0 0 2 0h-2Zm0-99v99h2V2h-2Z" fill="#000"/><path d="M49 59a1 1 0 1 0 0 2v-2Zm67 0H49v2h67v-2Z" fill="#000"/><path d="M99 60a1 1 0 1 0-2 0h2Zm0 41V60h-2v41h2Z" fill="#000"/>
              </svg>
              <h6>
                <number
                  :class="{ scaleBig: scaleClass }"
                  ref="number3"
                  :from="0"
                  animationPaused
                  :to="content.amenities.parking_spots"
                  :duration="duration"
                  easing="Power1.easeOut"
                  v-observe-visibility="{
                    callback: (isVisible, entry) =>
                      visibilityChanged(isVisible, entry, 'numbers'),
                    intersection: {
                      threshold: 0.3
                    }
                  }"
                />
                <span>{{ strings.total_rooms }}</span>
              </h6>
            </div>
            <!-- item -->
            <div class="project-details-block-item">
              <svg width="133" height="102" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="125.765" height="45.155" rx="22.491" transform="matrix(.99289 .11906 -.16479 .98633 7.441 21)" fill="#F9AF41"/><path stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M16 1h100v100H16z"/><path d="M32 50.5h-2.25a3.75 3.75 0 1 1 0-7.5h72.5a3.75 3.75 0 0 1 0 7.5H97M28 50.763h-1.237v12.775c0 9.775 7.924 17.699 17.7 17.699h43.074c9.775 0 17.7-7.924 17.7-17.7V50.764H28Z" stroke="#000" stroke-width="2.474"/><path d="m37.242 80.245-3.55 3.991M96.101 80.245l3.549 3.991M87.301 16.99v0a5.225 5.225 0 0 1 5.225-5.225H93.9a6.6 6.6 0 0 1 6.599 6.599V41.45" stroke="#000" stroke-width="2.474" stroke-linecap="round"/><path d="M56.76 67.514h1.238V48.817a6.225 6.225 0 0 0-6.226-6.226H44.45a6.225 6.225 0 0 0-6.226 6.226V67.514H56.76Z" fill="#F9AF41" stroke="#000" stroke-width="2.474"/><path d="M39.46 58.545h17.744M86.925 17.14v0a7.763 7.763 0 0 0-7.763 7.763v2.713h15.526v-2.713a7.763 7.763 0 0 0-7.763-7.763v0Z" stroke="#000" stroke-width="2.474" stroke-linecap="round"/>
              </svg>

              <h6>
                <number
                  :class="{ scaleBig: scaleClass }"
                  ref="number4"
                  :from="0"
                  animationPaused
                  :to="content.amenities.square_meters"
                  :duration="duration"
                  easing="Power1.easeOut"
                  v-observe-visibility="{
                    callback: (isVisible, entry) =>
                      visibilityChanged(isVisible, entry, 'numbers'),
                    intersection: {
                      threshold: 0.3
                    }
                  }"
                />
                <span>{{ strings.total_bai }}</span>
              </h6>
            </div>
            <!-- item -->
            <div class="project-details-block-item">
              <svg width="133" height="102" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="125.765" height="45.155" rx="22.491" transform="matrix(.99289 .11906 -.16479 .98633 7.441 21)" fill="#F9AF41"/><path stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M17 1h100v100H17z"/><path d="M89.544 36.911c0 8.49-5.34 16.294-10.865 22.07a70.98 70.98 0 0 1-10.037 8.647c-.143.1-.27.19-.382.266l-.382-.266a70.97 70.97 0 0 1-10.038-8.647c-5.524-5.776-10.865-13.58-10.865-22.07s5.341-16.294 10.865-22.07a70.961 70.961 0 0 1 10.038-8.647c.142-.1.27-.19.382-.266l.382.266A70.97 70.97 0 0 1 78.68 14.84c5.524 5.776 10.864 13.58 10.864 22.07ZM68.26 35.673V95.1" stroke="#000" stroke-width="2" stroke-linecap="round"/><path d="M43.005 84.254c3.89 3.89 9.944 5.04 15.214 5.158a46.684 46.684 0 0 0 8.689-.646l.099-.018.017-.099a46.697 46.697 0 0 0 .647-8.69c-.118-5.268-1.268-11.323-5.159-15.213-3.89-3.89-9.944-5.04-15.214-5.158a46.683 46.683 0 0 0-8.69.646l-.098.018-.017.098a46.68 46.68 0 0 0-.646 8.69c.117 5.27 1.267 11.324 5.158 15.214ZM53.377 75.118l11.872 9.498M93.226 84.254c-3.89 3.89-9.945 5.04-15.214 5.158a46.683 46.683 0 0 1-8.69-.646l-.098-.018a41.844 41.844 0 0 1-.314-2.112 46.683 46.683 0 0 1-.35-6.676c.117-5.27 1.268-11.323 5.158-15.214 3.89-3.89 9.945-5.04 15.214-5.158a46.684 46.684 0 0 1 8.69.646l.098.018.018.098a46.695 46.695 0 0 1 .647 8.69c-.118 5.27-1.269 11.324-5.16 15.214ZM82.853 75.118l-11.871 9.498" stroke="#000" stroke-width="1.918" stroke-linecap="round"/>
              </svg>

              <h6>
                <number
                  :class="{ scaleBig: scaleClass }"
                  ref="number5"
                  :from="0"
                  animationPaused
                  :to="content.amenities.garden"
                  :duration="duration"
                  easing="Power1.easeOut"
                  v-observe-visibility="{
                    callback: (isVisible, entry) =>
                      visibilityChanged(isVisible, entry, 'numbers'),
                    intersection: {
                      threshold: 0.3
                    }
                  }"
                />
                m² <span>{{ strings.curte }}</span>
              </h6>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Section: single img right -->
    <div class="section-wrapper">
      <div
        class="single-img mask-right single-img--four"
        :style="{
          backgroundImage: 'url(' + content.mediaFiles.image_2 + ')'
        }"
        :class="{ active: maskR1 }"
        v-observe-visibility="{
          callback: (isVisible, entry) =>
            visibilityChanged(isVisible, entry, 'maskR1'),
          intersection: {
            threshold: 0.3
          }
        }"
      ></div>
    </div>
    <!--  content -->
    <div class="subsection-wrapper margintop" v-if="content.title">
      <div class="shape shape--notitle"></div>
      <div class="about-us-content content active">
        <h3>
          {{ content.title }}
        </h3>
        <!-- <p>{{ content.subtitle }}</p> -->
        <p>{{ content.shortDescription }}</p>
      </div>
    </div>

    <!--  Section: aproape de tot -->
    <div
      class="subsection-wrapper nearbydetails"
      v-if="this.content.nearBy[0].distance"
    >
      <div class="content active">
        <h3>
          {{ strings.aproape_de_tot }}
        </h3>
        <ul class="nearbydetails-list">
          <!-- items -->
          <li
            v-for="(item, index) in content.nearBy"
            :key="index"
            class="nearbydetails-item "
            :class="'nearbydetails-item--' + item.by"
          >
            <span class="text">
              <span>{{ item.distance }}</span>
              <span>{{ item.destination }}</span>
            </span>
          </li>
          <!-- last item -->
          <li class="nearbydetails-item nearbydetails-item--final">
            <span class="text">
              <span>{{ zona_impanzita[0] }}</span>
              <span>{{ zona_impanzita[1] }}</span>
            </span>
          </li>
        </ul>
      </div>
    </div>

    <!-- Section: single img right -->
    <div class="section-wrapper" v-if="content.mediaFiles.image_3">
      <div
        class="single-img mask-right single-img--four"
        :style="{
          backgroundImage: 'url(' + content.mediaFiles.image_3 + ')'
        }"
        :class="{ active: maskR2 }"
        v-observe-visibility="{
          callback: (isVisible, entry) =>
            visibilityChanged(isVisible, entry, 'maskR2'),
          intersection: {
            threshold: 0.3
          }
        }"
      ></div>
    </div>
    <!--  content -->
    <div
      class="subsection-wrapper margintop"
      v-if="this.content.secondSubtitle.length > 5"
    >
      <div class="shape shape--notitle"></div>
      <div class="about-us-content content active">
        <h3>
          {{ content.secondSubtitle }}
        </h3>
        <p>
          {{ content.description }}
        </p>
      </div>
    </div>

    <!-- Section 3: single img right -->
    <div class="section-wrapper">
      <div
        class="single-img mask-right single-img--four"

        :class="{ active: maskRT2 }"
        v-observe-visibility="{
          callback: (isVisible, entry) =>
            visibilityChanged(isVisible, entry, 'maskRT2'),
          intersection: {
            threshold: 0.3
          }
        }"
      ></div>
    </div>
    <!--  content -->
    <div
      class="subsection-wrapper margintop"
      v-if="this.content.secondSubtitle.length > 5"
    >
      <div class="shape shape--notitle"></div>
      <div class="about-us-content content active">
        <h3>{{ this.content.thirdSubtitle }}</h3>
        <p>{{ this.content.secondDescription }}</p>
      </div>
    </div>

    <!-- Section: Int/Ext structure -->
    <div
      class="section-wrapper section-wrapper--int-ext"
      v-if="content.mediaFiles.interior"
    >
      <div
        class="int-ext-shadow mask-left"
        :class="{ active: maskR3 }"
        v-observe-visibility="{
          callback: (isVisible, entry) =>
            visibilityChanged(isVisible, entry, 'maskR3'),
          intersection: {
            threshold: 0.3
          }
        }"
      >
        <h2>{{ strings.structura_si_finisaje }}</h2>
      </div>
      <div
        class="int-ext mask-right"
        :class="{ active: maskR3 }"
        v-if="content.mediaFiles.interior"
        v-observe-visibility="{
          callback: (isVisible, entry) =>
            visibilityChanged(isVisible, entry, 'maskR3'),
          intersection: {
            threshold: 0.3
          }
        }"
      >
        <VueSlickCarousel v-bind="settings" @afterChange="swipeIntExt">
          <div><img :src="content.mediaFiles.interior" alt="" /></div>
          <div><img :src="content.mediaFiles.exterior" alt="" /></div>
        </VueSlickCarousel>
      </div>
    </div>

    <!-- Section: materials -->
    <div
      class="section-wrapper section-wrapper--materials"
      v-if="content.mediaFiles.interior"
    >
      <v-collapse-wrapper>
        <span
          class="button"
          v-collapse-toggle
          :class="{ 'button--collapse': isMaterialeVisible }"
          @click="toggleMaterialeList"
        >
          {{ strings.vezi_materiale }} <span>{{ sliderText.active }} </span>
          <svg
            width="28"
            height="9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M1.1821.629l12.8604 7.7857L26.9028.6289" stroke="#000" />
          </svg>
        </span>

        <div class="materials" v-collapse-content>
          <ul
            class="materials-list"
            v-if="sliderText.active === strings.exterioare"
          >
            <li
              class="materials-item"
              v-for="(material, index) in content.materials.exterior"
              :key="`materialExt-${index}`"
            >
              {{ material }}
            </li>
          </ul>
          <ul
            class="materials-list"
            v-if="sliderText.active === strings.interioare"
          >
            <li
              class="materials-item"
              v-for="(material, index) in content.materials.interior"
              :key="`materialInt-${index}`"
            >
              {{ material }}
            </li>
          </ul>
          <span class="materials-text">{{ strings.lista_completa }}</span>
          <a
            href="#"
            class="button button--download"
            @click.prevent="DownloadForm(true)"
            @keydown.esc="DownloadForm(false)"
            title="Download brochure"
            ><svg
              width="23"
              height="26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.6464 19.3536a.5002.5002 0 00.7072 0l3.1819-3.182a.5.5 0 000-.7071.5.5 0 00-.7071 0L12 18.2929l-2.8284-2.8284a.5.5 0 10-.7071.7071l3.1819 3.182zM11.5 0v19h1V0h-1z"
                fill="#000"
              />
              <path stroke="#000" d="M0 25.5h23" /></svg
          ></a>
        </div>
      </v-collapse-wrapper>
    </div>

    <!-- Section: Apart. types -->
    <div
      class="section-wrapper section-wrapper--apartments"
      ref="apartSlideWrapper"
      v-if="content.apartments.data.length > 0"
    >
      <div class="project-details-shadow our-projects-shadow mask-left active">
        <h2>{{ strings.compartimentare }}</h2>
      </div>

      <!-- Apart details -->
      <div class="project-details our-projects mask-right active"></div>
      <div class="apart-details">
        <VueSlickCarousel v-bind="settings3" @beforeChange="beforeApartSlide">
          <div
            class="apart-item"
            v-for="apartament in apartamente"
            :data-id="[apartament.id]"
            :key="apartament.id"
          >
            <div class="apart-item-headline">
              <!-- <h4>
                {{ apartament.nume }} <br />
                {{ apartament.etaj }}
              </h4> -->
              <!-- <h4>{{ apartament.etaj }}</h4> -->
            </div>
            <div class="apart-item-subheadline">
              <h5>
                {{ strings.tip_locuinta }}
                <span>{{ apartament.type }}</span>
              </h5>
              <h5>
                {{ strings.orientare }}
                <span
                  ><svg
                    width="59"
                    height="54"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      r="15.4707"
                      transform="rotate(-36.0324 60.4394 -19.5176) skewX(-.0008)"
                      stroke="#000"
                      stroke-width=".8"
                    />
                    <path
                      d="M10.2097 41.1547l22.1681-21.4092-13.8876 27.0857"
                      stroke="#000"
                      stroke-width=".8"
                    />
                    <path
                      d="M36.7955 20.3711l-.9228-.7402.8192-8.6257-4.5306 5.6485-.9228-.7402 5.7344-7.1494.9228.7402-.8273 8.6359 4.5387-5.6587.9228.7402-5.7344 7.1494z"
                      fill="#000"
                    /></svg
                ></span>
              </h5>
              <h5>
                {{ strings.suprafata_utila }}
                <span>{{ apartament.surface }} m²</span>
              </h5>
            </div>

            <div
              class="apart-item-floors"
              v-if="apartament.mediaFiles.level_2"
              :data-slide="1"
            >
              <button
                class="button button--white"
                type="button"
                name="button"
                @click="changeFloorPlan($event, 1, apartament.id)"
              >
                {{ strings.nivel }} 1
              </button>
              <button
                class="button button--white"
                type="button"
                name="button"
                @click="changeFloorPlan($event, 2, apartament.id)"
              >
                {{ strings.nivel }} 2
              </button>
            </div>
            <!-- floor plan -->
            <div class="apart-item-floorplan">
              <div class="apart-item-floorplan-left">
                <ul class="rooms-list">
                  <li
                    class="rooms-list-item"
                    v-for="camera in apartament.roomsDetails"
                    :key="camera.id"
                  >
                    <span class="room-ico">{{ camera.icon }}</span>
                    <span class="room-title">{{ camera.name }}</span>
                    <span class="room-sqm">{{ camera.surface }}</span>
                  </li>
                </ul>
              </div>
              <div class="apart-item-floorplan-right">
                <div class="apart-item-floorplan-wrapper">
                  <img :src="apartament.mediaFiles.level_1" alt="" />
                  <img
                    v-if="apartament.mediaFiles.level_2"
                    :src="apartament.mediaFiles.level_2"
                    alt=""
                  />
                  <img
                    v-if="apartament.mediaFiles.level_3"
                    :src="apartament.mediaFiles.level_3"
                    alt=""
                  />
                  <!-- <img
                    v-for="schita in apartament.mediaFiles"
                    :key="schita.id"
                    :src=""
                    alt=""
                  /> -->
                </div>
              </div>
            </div>
          </div>
        </VueSlickCarousel>
      </div>
    </div>

    <!-- tabel -->
    <div class="subsection-wrapper subsection-wrapper--table">
      <span class="download-text">{{ strings.vezi_toate_planurile }}</span>
      <a
        href="#"
        @click.prevent="DownloadForm(true)"
        @keydown.esc="DownloadForm(false)"
        class="button button--download"
        title="Download brochure"
        ><svg>
          <path
            d="M11.6464 19.3536a.5002.5002 0 00.7072 0l3.1819-3.182a.5.5 0 000-.7071.5.5 0 00-.7071 0L12 18.2929l-2.8284-2.8284a.5.5 0 10-.7071.7071l3.1819 3.182zM11.5 0v19h1V0h-1z"
            fill="#000"
          />
          <path stroke="#000" d="M0 25.5h23" /></svg
      ></a>
    </div>

    <!-- Proiectul in imagini -->
    <div class="section-wrapper" style="margin-top: 100px;" v-if="this.content.mediaFiles.schita">
      <div
        class="project-start-img-shadow mask-left"
        :class="{ active: maskR4 }"
        v-observe-visibility="{
          callback: (isVisible, entry) =>
            visibilityChanged(isVisible, entry, 'maskR4'),
          intersection: {
            threshold: 0.3
          }
        }"
      >
        <h2>{{ strings.proiectul_in_imagini }}</h2>
      </div>

      <div
        class="project-start-img mask-right"
        :style="{
          backgroundImage: 'url(' + this.content.mediaFiles.schita + ')'
        }"
        :class="{ active: maskR4 }"
        v-observe-visibility="{
          callback: (isVisible, entry) =>
            visibilityChanged(isVisible, entry, 'maskR4'),
          intersection: {
            threshold: 0.3
          }
        }"
      ></div>
    </div>
    <!-- Proiectul in imagini content -->
    <div class="subsection-wrapper" v-if="content.images.data.length > 0">
      <div class="shape shape--onlytitle"></div>
      <div class="project-start-img-content content active">
        <h3>{{ strings.descoperire }}</h3>
      </div>
    </div>

    <!-- Imagine 2-->
    <div class="section-wrapper" style="margin-top: 100px;">
      <div
        class="project-start-img epos-second-img mask-right"
        :class="{ active: maskRImg3 }"
        v-observe-visibility="{
          callback: (isVisible, entry) =>
            visibilityChanged(isVisible, entry, 'maskRImg3'),
          intersection: {
            threshold: 0.3
          }
        }"
      ></div>
    </div>
    <!-- Proiectul in imagini content -->
    <div class="subsection-wrapper subsection-wrapper--mt200" v-if="content.images.data.length > 0">
      <div class="shape shape--onlytitle"></div>
      <div class="project-start-img-content content active">
        <h3>{{ strings.reinterpretare }}</h3>
      </div>
    </div>

    <!-- single img left -->
    <div
      class="section-wrapper section-wrapper--lastsection"
      v-if="content.images.data.length > 0"
    >
      <div
        class="single-img mask-left"
        :class="{ active: maskR5 }"
        v-observe-visibility="{
          callback: (isVisible, entry) =>
            visibilityChanged(isVisible, entry, 'maskR5'),
          intersection: {
            threshold: 0.3
          }
        }"
      >
        <VueSlickCarousel v-bind="settings2" ref="carousel2">
          <div v-for="(img, index) in content.images.data" :key="index">
            <img :src="img.url[3].original" alt="" />
            <span class="gallery-fullscreen-ico" @click="showPhotoSwipe(index)">
              <svg
                width="30"
                height="30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  r="15"
                  transform="matrix(-1 0 0 1 15 15)"
                  fill="#FEFEFE"
                />
                <path
                  d="M22.4665 6.626a.593.593 0 01.593.593v5.3372a.593.593 0 01-1.186 0V7.812h-4.7441a.593.593 0 010-1.186h5.3371zm-4.2022 3.9566l3.7829-3.7829.8386.8387-3.7829 3.7829-.8386-.8387z"
                  fill="#000"
                />
                <path
                  d="M18.4727 11.2129l3.993-3.9931"
                  stroke="#000"
                  stroke-width="1.186"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M6.3897 7.219a.593.593 0 01.593-.593h5.3372a.593.593 0 010 1.186H7.5757v4.7442a.593.593 0 01-1.186 0V7.219zm3.9566 4.2023l-3.783-3.783.8387-.8386 3.783 3.7829-.8387.8387z"
                  fill="#000"
                />
                <path
                  d="M10.9756 11.2129L6.9825 7.2198"
                  stroke="#000"
                  stroke-width="1.186"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M6.9827 23.2959a.593.593 0 01-.593-.5931v-5.3371a.593.593 0 011.186 0v4.7441H12.32a.593.593 0 010 1.1861H6.9827zm4.2023-3.9567l-3.783 3.783-.8386-.8387 3.7829-3.7829.8387.8386z"
                  fill="#000"
                />
                <path
                  d="M10.9756 18.709l-3.9931 3.9931"
                  stroke="#000"
                  stroke-width="1.186"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M23.0586 22.7028a.593.593 0 01-.5931.5931h-5.3371a.593.593 0 010-1.1861h4.7441v-4.7441a.593.593 0 011.1861 0v5.3371zm-3.9567-4.2022l3.783 3.7829-.8387.8387-3.7829-3.783.8386-.8386z"
                  fill="#000"
                />
                <path
                  d="M18.4707 18.709l3.9931 3.9931"
                  stroke="#000"
                  stroke-width="1.186"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
          </div>
        </VueSlickCarousel>
      </div>
    </div>
    <!--  content -->
    <div class="subsection-wrapper" v-if="content.images.data.length > 0">
      <div class="shape shape--carousel"></div>
      <div class="about-us-content content active slider2">
        <h3>
          <!-- <span
            @click="moveSlide('prev')"
            class="slider2-arrow slider2-fake-prev"
          ></span> -->
          {{ strings.dezvoltare }}
          <!-- <span
            @click="moveSlide('next')"
            class="slider2-arrow slider2-fake-next"
          ></span> -->
        </h3>
      </div>
    </div>

    <!-- map -->
    <div class="section-wrapper" style="margin-top: 80px;z-index:80;">
      <div class="project-details-shadow our-projects-shadow mask-left active">
        <h2 class="poz-proiecte">
          {{ strings.pozitionare_proiecte_map_title }}
        </h2>
      </div>
    </div>
    <div class="project-map" ref="mapcontainer"></div>

    <!-- photoswipe gallery -->
    <v-photoswipe-gallery
      :isOpen="isOpenGallery"
      :options="optionsGallery"
      :items="fullscreenGalleryMobile"
      style="display: none;"
    >
      <!-- <img slot-scope="props" :src="props.item.src" alt="picture" /> -->
    </v-photoswipe-gallery>

    <v-photoswipe
      :isOpen="isOpen"
      :items="fullscreenGalleryMobile"
      :options="options"
      @close="hidePhotoSwipe"
    ></v-photoswipe>

    <!-- footer social -->
    <div class="social-footer">
      <div class="social-footer-wrapper">
        <div class="social-footer-network">
          <a :href="fbUrl" target="_blank" class="icon fb">
            <svg
              width="64"
              height="34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                width="59.2"
                height="24.9"
                rx="12.5"
                transform="rotate(8.1 .2 31.5)"
                fill="#F9AF41"
              />
              <path
                d="M28 32.5h6.5V16.3H39l.4-5.5h-4.9v-3c0-1.4.3-2 1.6-2h3.5V.4H35c-4.8 0-7 2-7 6.1v4.4h-3.4v5.5h3.4v16.2H28z"
                fill="#222221"
              />
            </svg>
          </a>
          <a :href="igUrl" target="_blank" class="icon ig"
            ><svg
              width="63"
              height="34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                width="59.2"
                height="24.9"
                rx="12.5"
                transform="rotate(8.1 0 27.5)"
                fill="#F9AF41"
              />
              <path
                d="M31.2 5.7c4 0 4.3 0 5.9.2a5 5 0 012.6.5c.7.3 1.1.6 1.7 1.2.6.5.8 1 1.1 1.6.2.6.4 1.3.6 2.7l.1 5.9-.1 5.9a5 5 0 01-.6 2.6c-.3.7-.5 1.2-1 1.7-.7.6-1 .9-1.8 1.1-.5.2-1.2.5-2.6.6l-6 .1-5.8-.1a5 5 0 01-2.7-.6c-.7-.2-1-.5-1.6-1-.6-.6-.9-1-1.2-1.8-.1-.5-.4-1.2-.5-2.6-.2-1.6-.2-2-.2-6 0-3.8 0-4.3.2-5.8a5 5 0 01.5-2.7c.3-.7.6-1 1.2-1.6.5-.6 1-.9 1.6-1.2.6-.1 1.3-.4 2.7-.5 1.4-.2 2-.2 5.9-.2zm0-2.6l-6 .1c-1.6.2-2.7.3-3.5.7-1 .4-1.9.9-2.6 1.7-.8.8-1.2 1.7-1.6 2.5-.5 1-.6 2-.7 3.5-.2 1.6-.2 2.1-.2 6 0 4 0 4.5.2 6 0 1.6.2 2.7.7 3.6.4 1 .8 1.8 1.6 2.5.9.8 1.7 1.3 2.6 1.7 1 .4 2 .5 3.5.7l6 .1 6-.1c1.5-.2 2.7-.3 3.5-.7 1-.4 1.8-.9 2.5-1.7.9-.8 1.3-1.7 1.7-2.5.4-1 .6-2 .7-3.5.2-1.6.2-2.1.2-6 0-4 0-4.5-.2-6C45.5 10 45.3 9 45 8c-.4-1-.8-1.8-1.7-2.5a8.8 8.8 0 00-2.5-1.7c-1-.4-2-.5-3.5-.7l-6-.1z"
                fill="#222221"
              />
              <path
                d="M31.2 10.2a7.5 7.5 0 00-7.6 7.6c0 4.2 3.4 7.6 7.6 7.6 4.2 0 7.5-3.4 7.5-7.6a7.7 7.7 0 00-7.5-7.6zm0 12.5a5 5 0 01-5-5 5 5 0 015-4.8 5 5 0 014.9 4.9c-.2 2.7-2.3 4.9-5 4.9zM40.7 10c0 1-.8 1.8-1.8 1.8S37 10.9 37 9.9c0-1 .8-1.8 1.8-1.8 1 .2 1.8.9 1.8 1.8z"
                fill="#222221"
              /></svg
          ></a>
          <a :href="liUrl" target="_blank" class="icon in">
            <svg
              width="63"
              height="34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                width="59.2"
                height="24.9"
                rx="12.5"
                transform="rotate(8.1 .2 30.7)"
                fill="#F9AF41"
              />
              <path fill="#000" d="M14.9 10.2h7.4v22.7h-7.4z" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M33.9 19.7c.5-1.6 2-3.7 4.4-3.7 2.3 0 3.5 2.3 3.5 3.4h7.4c0-1.9-.5-6-4-8.3-1.4-1-5.3-2.3-8.8 0-.8.6-1.8 1.7-2.5 3v-4h-7.4V33h7.4V19.7zm7.9-.3h7.4V33h-7.4V19.4z"
                fill="#000"
              />
              <ellipse cx="18.9" cy="3.7" rx="3.9" ry="3.7" fill="#000" />
            </svg>
          </a>
        </div>
        <span
          ><router-link v-bind:to="'/privacypolicy'">{{
            strings.privacy_title
          }}</router-link></span
        >
        <span>{{ strings.all_rights_reserved }}</span>
      </div>
      <!-- scroll to top -->
      <div class="scroll-to-top">
        <a href="#" @click.prevent="scrollTo('.project-hero')">
          <svg
            width="24"
            height="34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 1c-.5-.6-1.5-.6-2 0l-9.6 9.5a1.5 1.5 0 102.1 2.1L12 4.1l8.5 8.5a1.5 1.5 0 102.1-2.1L13.1.9zm.5 33V2h-3v32h3z"
              fill="#000"
            />
          </svg>
        </a>
      </div>
    </div>

    <!-- -->
  </div>
</template>

<script>
import axios from "axios";
import smoothscroll from "smoothscroll-polyfill";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import gmapsInit from "../utils/gmaps";
import router from "../router";
import { bus } from "../main";
import dateFormat from "dateformat";
import { PhotoSwipe, PhotoSwipeGallery } from "v-photoswipe";
// import { ModelFbx } from 'vue-3d-model';

// kick off the polyfill!
smoothscroll.polyfill();

export default {
  name: "Project",
  components: {
    // ModelFbx,
    VueSlickCarousel,
    "v-photoswipe": PhotoSwipe,
    "v-photoswipe-gallery": PhotoSwipeGallery
  },
  data() {
    return {
      isOpen: false,
      isOpenGallery: false,
      options: {
        index: 0,
        fullscreenEl: false,
        shareEl: true,
        captionEl: false,
        zoomEl: true,
        shareButtons: [
          {
            id: "download",
            label: "Download image",
            url: "{{raw_image_url}}",
            download: true
          }
        ]
      },
      optionsGallery: {
        zoomEl: true
      },
      fullscreenGalleryMobile: [
        {
          src:
            "https://farm4.staticflickr.com/3894/15008518202_c265dfa55f_h.jpg",
          w: 1600,
          h: 1600
        }
      ],
      viewportW: window.matchMedia("(max-width: 1024px)").matches ? 400 : 1000,
      viewportH: window.matchMedia("(max-width: 1024px)").matches ? 300 : 600,
      enablePan: true,
      enableZoom: true,
      enableRotate: true,
      screenSpacePanning: false,
      cameraposition: {
        x: 0,
        y: 0,
        z: 0
      },
      rotation: {
                x: 0,
                y: 0,
                z: 0
            },
      locale: "",
      form_type: "",
      user_name: "",
      user_email: "",
      user_phone: "",
      user_date: "",
      user_message: "",
      isMobile: false,
      isMaterialeVisible: false,
      isApartPosActive: false,
      apartDetailsH: null,
      maskR1: false,
      maskR2: false,
      maskRT2: false,
      maskR3: false,
      maskR4: false,
      maskR5: false,
      maskRImg3: false,
      duration: 2,
      scaleClass: false,
      settings: {
        dots: false,
        arrows: true,
        dotsClass: "slick-dots custom-dot-class",
        edgeFriction: 0.35,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1
      },
      settings2: {
        dots: false,
        arrows: false,
        infinite: true,
        autoplay: false,
        pauseOnHover: false,
        edgeFriction: 0.35,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
      },
      settings3: {
        dots: false,
        arrows: true,
        infinite: false,
        edgeFriction: 0.35,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
      },
      sliderText1: {
        0: "Confort și finisaje",
        1: "Structură și finisaje",
        active: "Confort și finisaje"
      },
      sliderText: {
        0: "interioare",
        1: "exterioare",
        active: "interioare"
      },
      strings: {
        programeaza_intalnire_cta: "",
        programeaza_intalnire_headline: "",
        programeaza_intalnire_thanks: "",
        brosura_headline: "",
        apartamente: "",
        parcare: "",
        boxe: "",
        construiti: "",
        gradina: "",
        suprafata_utila: "",
        suprafata_totala: "",
        total_rooms: "",
        total_bai: "",
        curte: "",
        aproape_de_tot: "",
        vezi_materiale: "",
        lista_completa: "",
        tipuri_apartamente: "",
        tip_apartament: "",
        orientare: "",
        nivel: "",
        pozitionare_apartament: "",
        tabel_apt: "",
        tabel_nivel: "",
        tabel_curte: "",
        tabel_terasa: "",
        tabel_utili: "",
        tabel_camere: "",
        tabel_dormitoare: "",
        tabel_bai: "",
        tabel_disponibilitate: "",
        vezi_toate_planurile: "",
        proiectul_in_imagini: "",
        de_la_schita: "",
        la_dezvoltare: "",
        pozitionare_proiecte_map_title: "",
        all_rights_reserved: "",
        vezi_evolutia: "",
        compartimentare: "",
        descoperire: "",
        reinterpretare: "",
        dezvoltare: ""
      },
      zona_impanzita: {},
      content: {
        name: "",
        year: "",
        status: "",
        address: "",
        title: "",
        subtitle: "",
        shortDescription: "",
        secondSubtitle: "",
        description: "",
        brochureUrl: ""
      },
      apartamente: [],
      fbUrl: "",
      igUrl: "",
      liUrl: ""
    };
  },
  methods: {
    fetchData: function() {
      var self = this;

      // console.log("locale is: " + self.locale);
      // reset strings
      self.strings.programeaza_intalnire_cta = "";
      self.strings.programeaza_intalnire_headline = "";
      self.strings.programeaza_intalnire_thanks = "";
      self.strings.brosura_headline = "";
      self.strings.apartamente = "";
      self.strings.parcare = "";
      self.strings.boxe = "";
      self.strings.construiti = "";
      self.strings.gradina = "";
      self.strings.aproape_de_tot = "";
      self.strings.vezi_materiale = "";
      self.strings.lista_completa = "";
      self.strings.tipuri_apartamente = "";
      self.strings.tip_apartament = "";
      self.strings.orientare = "";
      self.strings.suprafata_utila = "";
      self.strings.nivel = "";
      self.strings.pozitionare_apartament = "";
      self.strings.tabel_apt = "";
      self.strings.tabel_curte = "";
      self.strings.tabel_terasa = "";
      self.strings.tabel_utili = "";
      self.strings.tabel_camere = "";
      self.strings.tabel_dormitoare = "";
      self.strings.tabel_bai = "";
      self.strings.tabel_disponibilitate = "";
      self.strings.vezi_toate_planurile = "";
      self.strings.proiectul_in_imagini = "";
      self.strings.de_la_schita = "";
      self.strings.la_dezvoltare = "";
      self.strings.pozitionare_proiecte_map_title = "";
      self.strings.all_rights_reserved = "";
      self.strings.suprafata_totala = "";

      // content
      axios
        .get(
          "https://api.riseapart.com/project" +
            "?slug=" +
            this.$route.params.slug,
          {
            headers: {
              "X-Locale": self.locale
            }
          }
        )
        .then(function(data) {
          self.content = data.data.data[0];
          // console.log("content: ", self.locale, self.content);

          // console.log(self.content.apartments.data[0].mediaFiles.level_6);

          // apartamente
          self.apartamente = self.content.apartments.data;

          // brosura
          self.content.brochureUrl = self.content.mediaFiles.brochure;
          // console.log(self.content.brochureUrl);

          //
          let x;
          for (x = 0; x < self.apartamente.length; x++) {
            self.apartamente[x].nameFull = self.apartamente[x].name.split("-");

            if (self.apartamente[x].nameFull.length > 2) {
              self.apartamente[x].nume =
                self.apartamente[x].nameFull[0] +
                "-" +
                self.apartamente[x].nameFull[1];
            } else {
              self.apartamente[x].nume = self.apartamente[x].nameFull[0];
            }

            self.apartamente[x].etaj =
              self.apartamente[x].nameFull[
                self.apartamente[x].nameFull.length - 1
              ];
          }

          if (self.content.zone) {
            self.zona_impanzita[0] = self.content.zone.split("|")[0];
            self.zona_impanzita[1] = self.content.zone.split("|")[1];
          }

          // poze galerie
          if (self.content.images.data) {
            self.fullscreenGalleryMobile = [];

            for (let y = 0; y < self.content.images.data.length; y++) {
              self.fullscreenGalleryMobile.push({
                src: self.content.images.data[y].url[3].original,
                w: 1600,
                h: 1600
              });
            }
          }

          //
          self.getHeight();

          //
          self.initMaps();
        })
        .catch(function(error) {
          console.log("Error", error);
        });

      // get translatable strings
      axios
        .get("https://api.riseapart.com/content?_limit=120", {
          headers: { "X-Locale": self.locale }
        })
        .then(function(data) {
          let stringsObj = data.data.data;
          let x;

          for (x = 0; x < stringsObj.length; x++) {
            let newObj = stringsObj[x];
            let newKey = Object.keys(newObj);
            self.strings[newObj[newKey].key] = newObj[newKey].value;

            //
            self.sliderText[0] = self.strings.interioare;
            self.sliderText[1] = self.strings.exterioare;
            self.sliderText.active = self.strings.interioare;
            //
            self.sliderText1[0] = self.strings.confort_si_finisaje;
            self.sliderText1[1] = self.strings.structura_si_finisaje;
            self.sliderText1.active = self.strings.confort_si_finisaje;
          }

          // check brochure headline
          if (localStorage.getItem("brochureDownloaded") === "true") {
            self.strings.brosura_headline =
              self.strings.brosure_headline_alreadydownloaded;
          }

          // console.log("strings: ", self.locale, self.strings);
        })
        .catch(function(error) {
          console.log("Error", error);
        });

      // get settings (social urls)
      axios
        .get("https://api.riseapart.com/configuration")
        .then(function(res) {
          var facebookUrl = res.data.data.filter(obj => {
            return obj.key === "FACEBOOK_URL";
          });

          var instagramUrl = res.data.data.filter(obj => {
            return obj.key === "INSTAGRAM_URL";
          });

          var linkedinUrl = res.data.data.filter(obj => {
            return obj.key === "LINKEDIN_URL";
          });

          self.fbUrl = facebookUrl[0].defaultValue;
          self.igUrl = instagramUrl[0].defaultValue;
          self.liUrl = linkedinUrl[0].defaultValue;
        })
        .catch(function(error) {
          console.log("Error", error);
        });
    },
    AppointmentForm(bool) {
      const el = document.querySelector(".appointment-form");
      if (bool) {
        document.querySelector("#date").value = dateFormat(
          new Date(),
          "yyyy-mm-dd"
        );
        el.classList.add("visible");
      } else {
        el.classList.remove("visible");
      }
    },
    DownloadForm(bool) {
      const el = document.querySelector(".download-form");
      if (bool) {
        el.classList.add("visible");
      } else {
        el.classList.remove("visible");
      }
    },
    StepIn(bool) {
      // console.log("ref2: ", this.$refs.model3d.src)
      this.$refs.model3d.src = this.content.apartments.data[0].mediaFiles.level_6;
      const el = document.querySelector(".step-in-view");
      if (bool) {
        el.classList.add("visible");
      } else {
        el.classList.remove("visible");
      }
    },
    forceDownloadFile(brochureUrl) {
      var self = this;
      axios({
        method: "get",
        url: brochureUrl,
        responseType: "arraybuffer"
      })
        .then(() => {
          // console.log(response);

          // const url = window.URL.createObjectURL(
          //   new Blob([response.data], { type: "application/pdf" })
          // );
          const link = document.createElement("a");
          link.target = "_blank";
          link.href = brochureUrl;
          link.setAttribute("download", "RiseApart-BrosuraPrecupetiiVechi.pdf"); //or any other extension
          document.body.appendChild(link);
          link.click();

          // set local storage
          localStorage.setItem("brochureDownloaded", "true");

          // close form
          self.DownloadForm(false);
        })
        .catch(() => console.log("error occured"));
    },
    submitForm(e) {
      e.preventDefault();

      // console.log(e);
      var form = e.srcElement;
      var form_type = form.querySelector("#form_type").value;

      let bodyFormData = new FormData();
      bodyFormData.set("project", this.content.id);
      bodyFormData.set("type", form_type);
      bodyFormData.set("email", this.user_email);
      bodyFormData.set("name", this.user_name);
      bodyFormData.set("phone", this.user_phone);
      bodyFormData.set("message", this.user_message);
      bodyFormData.set("date", dateFormat(this.user_date, "dd-mm-yyyy"));
      bodyFormData.set("tos", "true");

      // set loading animation on button
      form.querySelector('input[type="submit"]').classList.add("loading");

      if (
        document.querySelector("#subscribe_newsletter") ||
        document.querySelector("#subscribe_newsletter").checked
      ) {
        bodyFormData.set("news", true);
      }

      var self = this;

      // important to force new window on mobile.
      if (self.isMobile) {
        var importantStuff = window.open("", "_blank");
      }

      axios({
        method: "post",
        url: "https://api.riseapart.com/send-form",
        data: bodyFormData,
        headers: { "Content-Type": "multipart/form-data" }
      })
        .then(function(response) {
          // stop loading animation
          form
            .querySelector('input[type="submit"]')
            .classList.remove("loading");

          // handle success
          // meeting
          if (response.data.data.sent === 1 && form_type === "meeting") {
            // thank you message
            form.parentElement.querySelector("h5").style.display = "none";
            form.style.display = "none";
            form.parentElement.querySelector("h6").style.display = "block";
          }

          // brochure
          if (response.data.data.sent === 1 && form_type === "brochure") {
            const brochureUrl = response.data.data.brochure;

            // start download
            if (brochureUrl) {
              if (self.isMobile) {
                // self.forceDownloadFile(brochureUrl);
                // window.open(brochureUrl);
                // update on forcing new window to open on mobile.
                importantStuff.location.href = brochureUrl;
              } else {
                const link = document.createElement("a");
                link.href = brochureUrl;
                link.target = "_blank";
                link.setAttribute(
                  "download",
                  "RiseApart-BrosuraPrecupetiiVechi.pdf"
                ); //or any other extension
                document.body.appendChild(link);

                //
                setTimeout(function() {
                  link.click();
                }, 1000);
                // close form
                self.DownloadForm(false);
              }
              //
            } else {
              // thank you message
            }
          }
        })
        .catch(function(response) {
          // stop loading animation
          form
            .querySelector('input[type="submit"]')
            .classList.remove("loading");

          //handle error
          // console.log("error: " + response);

          if (response.name) {
            form
              .querySelector("input[name='user_name']")
              .classList.add("error");
          }

          if (response.email) {
            form
              .querySelector("input[name='user_email']")
              .classList.add("error");
          }

          if (response.phone) {
            form
              .querySelector("input[name='user_phone']")
              .classList.add("error");
          }
        });
    },
    swipeIntExt(slideIndex) {
      // console.log(slideIndex, this.sliderText)
      this.sliderText.active = this.sliderText[slideIndex];
      this.sliderText1.active = this.sliderText1[slideIndex];
    },
    visibilityChanged(isVisible, entry, param) {
      if (isVisible && param === "numbers") {
        this.scaleClass = false;
        this.$refs.number1.restart();
        this.$refs.number2.restart();
        this.$refs.number3.restart();
        this.$refs.number4.restart();
        this.$refs.number5.restart();
      }

      // if visible
      if (isVisible) {
        if (param === "maskR1") {
          this.maskR1 = true;
        }

        if (param === "maskR2") {
          this.maskR2 = true;
        }

        if (param === "maskRT2") {
          this.maskRT2 = true;
        }

        if (param === "maskR3") {
          this.maskR3 = true;
        }

        if (param === "maskR4") {
          this.maskR4 = true;
        }

        if (param === "maskRImg3") {
          this.maskRImg3 = true;
        }

        if (param === "maskR5") {
          this.maskR5 = true;
        }
      }

      if (!isVisible) {
        if (param === "maskR1") {
          this.maskR1 = false;
        }

        if (param === "maskR2") {
          this.maskR2 = false;
        }

        if (param === "maskRT2") {
          this.maskRT2 = false;
        }

        if (param === "maskR3") {
          this.maskR3 = false;
        }

        if (param === "maskR4") {
          this.maskR4 = false;
        }

        if (param === "maskR5") {
          this.maskR5 = false;
        }

        if (param === "maskRImg3") {
          this.maskRImg3 = false;
        }
      }
    },
    scrollTo(el) {
      setTimeout(function(){
        document.querySelector(el).scrollIntoView({
          behavior: "smooth"
        });
      }, 500);

    },
    moveSlide(param) {
      if (param === "next") {
        this.$refs.carousel2.next();
      }
      if (param === "prev") {
        this.$refs.carousel2.prev();
      }
    },
    updateFakeArrows(slideIndex) {
      var allSlidesLength = document.querySelectorAll(
        ".section-wrapper--lastsection img"
      ).length;
      var prev = document.querySelector(".slider2-fake-prev");
      var next = document.querySelector(".slider2-fake-next");

      if (slideIndex === 0) {
        prev.classList.add("disabled");
      } else {
        prev.classList.remove("disabled");
      }

      if (slideIndex + 1 === allSlidesLength) {
        next.classList.add("disabled");
      } else {
        next.classList.remove("disabled");
      }
    },
    changeFloorPlan($event, index, id) {
      const wrapper = document.querySelector(
        ".apart-item[data-id='" + id + "']"
      );
      const slider = wrapper.querySelector(".apart-item-floorplan-wrapper");
      wrapper
        .querySelector(".apart-item-floors")
        .setAttribute("data-slide", index);
      slider.style.transform = "translate3d(" + (index - 1) * -100 + "%,0,0)";
    },
    toggleApartPos() {
      this.isApartPosActive = !this.isApartPosActive;
      this.getHeight();
    },
    toggleMaterialeList() {
      this.isMaterialeVisible = !this.isMaterialeVisible;
    },
    getHeight() {
      // todo: refactor
      // console.log("set h");
      setTimeout(
        function() {
          if (this.$refs.apartSlideWrapper) {
            const h = this.$refs.apartSlideWrapper.querySelector(
              ".slick-current"
            ).offsetHeight;
            this.$refs.apartSlideWrapper.style.height = h + 470 + "px";
          }
        }.bind(this),
        10
      );
    },
    beforeApartSlide() {
      if (this.$refs.apartSlideWrapper) {
        this.getHeight();
      }
    },
    mq() {
      this.isMobile = window.matchMedia("(max-width: 1024px)").matches;
    },
    toggleVideo(bool) {
      var elem = document.querySelector(".fullscreen-video");
      if (bool) {
        document.querySelector(".mobile-video").classList.add("show");
        document
          .querySelector(".video-controls")
          .setAttribute("data-playing", "true");
        elem.play();
      } else {
        // document.querySelector(".mobile-video").classList.remove("show");
        document
          .querySelector(".video-controls")
          .setAttribute("data-playing", "false");
        elem.pause();
      }
    },
    showPhotoSwipe(index) {
      this.isOpen = true;
      this.$set(this.options, "index", index);
    },
    hidePhotoSwipe() {
      this.isOpen = false;
    },
    setScrollPos() {
      var loaded = document.querySelector("html");
      if (
        this.$route.query.cta == "smart-home" &&
        !loaded.classList.contains("loaded")
      ) {
        document.querySelector(".apart-details").scrollIntoView({
          behavior: "auto"
        });
        loaded.classList.add("loaded");
      }
    },
    onModelLoad() {
      // console.log("ref1: ", this.$refs.viewer3d)
      const el = document.querySelector(".viewer3d");
      el.classList.add("hide-loader");
    },
    async initMaps() {
      // gmaps
      try {
        const google = await gmapsInit();
        const precupeti = { lat: 44.44769, lng: 26.11796 };
        const ronda = { lat: 44.43691, lng: 26.12572 };
        const fainari = { lat: 44.44866, lng: 26.12109 };
        const center = { lat: 44.444722, lng: 26.120497 };
        const murgu = { lat: 44.42883, lng: 26.12700 };
        //
        var map = new google.maps.Map(document.querySelector(".project-map"), {
          center: center,
          zoom: 14,
          styles: [
            {
              elementType: "geometry",
              stylers: [
                {
                  color: "#f5f5f5"
                }
              ]
            },
            {
              elementType: "labels.icon",
              stylers: [
                {
                  visibility: "off"
                }
              ]
            },
            {
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#616161"
                }
              ]
            },
            {
              elementType: "labels.text.stroke",
              stylers: [
                {
                  color: "#f5f5f5"
                }
              ]
            },
            {
              featureType: "administrative.land_parcel",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#bdbdbd"
                }
              ]
            },
            {
              featureType: "poi",
              elementType: "geometry",
              stylers: [
                {
                  color: "#eeeeee"
                }
              ]
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#757575"
                }
              ]
            },
            {
              featureType: "poi.park",
              elementType: "geometry",
              stylers: [
                {
                  color: "#e5e5e5"
                }
              ]
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#9e9e9e"
                }
              ]
            },
            {
              featureType: "road",
              elementType: "geometry",
              stylers: [
                {
                  color: "#ffffff"
                }
              ]
            },
            {
              featureType: "road.arterial",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#757575"
                }
              ]
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [
                {
                  color: "#dadada"
                }
              ]
            },
            {
              featureType: "road.highway",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#616161"
                }
              ]
            },
            {
              featureType: "road.local",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#9e9e9e"
                }
              ]
            },
            {
              featureType: "transit.line",
              elementType: "geometry",
              stylers: [
                {
                  color: "#e5e5e5"
                }
              ]
            },
            {
              featureType: "transit.station",
              elementType: "geometry",
              stylers: [
                {
                  color: "#eeeeee"
                }
              ]
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [
                {
                  color: "#c9c9c9"
                }
              ]
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#9e9e9e"
                }
              ]
            }
          ]
        });
        // The markers
        var markers = [];

        markers[0] = new google.maps.Marker({
          position: precupeti,
          url: "precupetii-vechi",
          icon: {
            url: require("../assets/precupetii-marker_" + this.locale + ".png"),
            size: new google.maps.Size(117, 168),
            scaledSize: new google.maps.Size(117, 168)
          },
          map: map
        });
        markers[1] = new google.maps.Marker({
          position: ronda,
          url: "ronda",
          icon: {
            url: require("../assets/ronda-marker_" + this.locale + ".png"),
            size: new google.maps.Size(117, 168),
            scaledSize: new google.maps.Size(117, 168)
          },
          map: map
        });
        markers[2] = new google.maps.Marker({
          position: fainari,
          url: "fainari",
          icon: {
            url: require("../assets/fainari-marker_" + this.locale + ".png"),
            size: new google.maps.Size(117, 168),
            scaledSize: new google.maps.Size(117, 168)
          },
          map: map
        });
        markers[3] = new google.maps.Marker({
          position: murgu,
          url: "eftimie-murgu",
          icon: {
            url: require("../assets/murgu-marker_" + this.locale + ".png"),
            size: new google.maps.Size(117, 168),
            scaledSize: new google.maps.Size(117, 168)
          },
          map: map
        });

        // set marker url
        for (var i = 0; i < markers.length; i++) {
          google.maps.event.addListener(markers[i], "click", function() {
            if (this.url === 'eftimie-murgu') {
              router.push({ path: `/project-epos/${this.url}` });
            } else {
              router.push({ path: `/project/${this.url}` });
            }
          });
        }
      } catch (error) {
        console.error(error);
      }
    }
  },
  updated: function() {
    // console.log(this.$route.query.stepin);
    //
    if (this.$route.query.stepin == "3d") {
      this.scrollTo('.apart-item-headline');
      router.push({ query: { stepin: '' }})
    }
    //
    // console.log("CTA: ", this.$route.query.cta);
    // console.log(document.querySelector(".smart-home-btn"));
    // if (this.$route.query.cta) {
    //   document.querySelector(".smart-home-btn").scrollIntoView({
    //     behavior: "smooth"
    //   });
    // }
    this.setScrollPos();
  },
  created() {
    // langCheck
    // console.log(this.$route.query.lang);
    if (!this.$route.query.lang) {
      router.push({ query: { lang: "ro" } });
      this.locale = "ro";
    } else {
      this.locale = this.$route.query.lang;
      this.fetchData();
    }

    // lang switch
    bus.$on("lang", data => {
      this.locale = data.lang;
      this.fetchData();
    });
    //
    // this.fetchData();
    //
    localStorage.setItem("loaded", "true");
    //
    this.$nextTick(function() {
      if (this.$refs.apartSlideWrapper) {
        this.getHeight();
      }
    });
    //
    this.$nextTick(function() {
      window.addEventListener("resize", this.mq);
      window.addEventListener("resize", this.getHeight);
    });
    this.mq();

    //
    // if (this.$route.query.cta == "smart-home") {
    //   document.querySelector(".smart-home").scrollIntoView({
    //     behavior: "smooth"
    //   });
    // }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.mq);
  },
  async mounted() {},
  computed: {},
  destroyed() {},
  watch: {
    "$route.params": {
      handler() {
        // this.fetchData(); // rm breaking nav consistency
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss">
@import "~@/assets/styles/_reset.scss";
@import "~@/assets/styles/_variables.scss";
@import "~@/assets/styles/_components.scss";
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;600&display=swap");

html {
  &.loaded {
    scroll-behavior: smooth;
  }
}

.button-play-video {
  margin: 20px 0;
  z-index: 100;
}

.pswp__button--close,
.pswp__button--zoom {
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQgAAABYCAYAAAAJD2m8AAAKQ2lDQ1BJQ0MgcHJvZmlsZQAAeNqdU3dYk/cWPt/3ZQ9WQtjwsZdsgQAiI6wIyBBZohCSAGGEEBJAxYWIClYUFRGcSFXEgtUKSJ2I4qAouGdBiohai1VcOO4f3Ke1fXrv7e371/u855zn/M55zw+AERImkeaiagA5UoU8Otgfj09IxMm9gAIVSOAEIBDmy8JnBcUAAPADeXh+dLA//AGvbwACAHDVLiQSx+H/g7pQJlcAIJEA4CIS5wsBkFIAyC5UyBQAyBgAsFOzZAoAlAAAbHl8QiIAqg0A7PRJPgUA2KmT3BcA2KIcqQgAjQEAmShHJAJAuwBgVYFSLALAwgCgrEAiLgTArgGAWbYyRwKAvQUAdo5YkA9AYACAmUIszAAgOAIAQx4TzQMgTAOgMNK/4KlfcIW4SAEAwMuVzZdL0jMUuJXQGnfy8ODiIeLCbLFCYRcpEGYJ5CKcl5sjE0jnA0zODAAAGvnRwf44P5Dn5uTh5mbnbO/0xaL+a/BvIj4h8d/+vIwCBAAQTs/v2l/l5dYDcMcBsHW/a6lbANpWAGjf+V0z2wmgWgrQevmLeTj8QB6eoVDIPB0cCgsL7SViob0w44s+/zPhb+CLfvb8QB7+23rwAHGaQJmtwKOD/XFhbnauUo7nywRCMW735yP+x4V//Y4p0eI0sVwsFYrxWIm4UCJNx3m5UpFEIcmV4hLpfzLxH5b9CZN3DQCshk/ATrYHtctswH7uAQKLDljSdgBAfvMtjBoLkQAQZzQyefcAAJO/+Y9AKwEAzZek4wAAvOgYXKiUF0zGCAAARKCBKrBBBwzBFKzADpzBHbzAFwJhBkRADCTAPBBCBuSAHAqhGJZBGVTAOtgEtbADGqARmuEQtMExOA3n4BJcgetwFwZgGJ7CGLyGCQRByAgTYSE6iBFijtgizggXmY4EImFINJKApCDpiBRRIsXIcqQCqUJqkV1II/ItchQ5jVxA+pDbyCAyivyKvEcxlIGyUQPUAnVAuagfGorGoHPRdDQPXYCWomvRGrQePYC2oqfRS+h1dAB9io5jgNExDmaM2WFcjIdFYIlYGibHFmPlWDVWjzVjHVg3dhUbwJ5h7wgkAouAE+wIXoQQwmyCkJBHWExYQ6gl7CO0EroIVwmDhDHCJyKTqE+0JXoS+cR4YjqxkFhGrCbuIR4hniVeJw4TX5NIJA7JkuROCiElkDJJC0lrSNtILaRTpD7SEGmcTCbrkG3J3uQIsoCsIJeRt5APkE+S+8nD5LcUOsWI4kwJoiRSpJQSSjVlP+UEpZ8yQpmgqlHNqZ7UCKqIOp9aSW2gdlAvU4epEzR1miXNmxZDy6Qto9XQmmlnafdoL+l0ugndgx5Fl9CX0mvoB+nn6YP0dwwNhg2Dx0hiKBlrGXsZpxi3GS+ZTKYF05eZyFQw1zIbmWeYD5hvVVgq9ip8FZHKEpU6lVaVfpXnqlRVc1U/1XmqC1SrVQ+rXlZ9pkZVs1DjqQnUFqvVqR1Vu6k2rs5Sd1KPUM9RX6O+X/2C+mMNsoaFRqCGSKNUY7fGGY0hFsYyZfFYQtZyVgPrLGuYTWJbsvnsTHYF+xt2L3tMU0NzqmasZpFmneZxzQEOxrHg8DnZnErOIc4NznstAy0/LbHWaq1mrX6tN9p62r7aYu1y7Rbt69rvdXCdQJ0snfU6bTr3dQm6NrpRuoW623XP6j7TY+t56Qn1yvUO6d3RR/Vt9KP1F+rv1u/RHzcwNAg2kBlsMThj8MyQY+hrmGm40fCE4agRy2i6kcRoo9FJoye4Ju6HZ+M1eBc+ZqxvHGKsNN5l3Gs8YWJpMtukxKTF5L4pzZRrmma60bTTdMzMyCzcrNisyeyOOdWca55hvtm82/yNhaVFnMVKizaLx5balnzLBZZNlvesmFY+VnlW9VbXrEnWXOss623WV2xQG1ebDJs6m8u2qK2brcR2m23fFOIUjynSKfVTbtox7PzsCuya7AbtOfZh9iX2bfbPHcwcEh3WO3Q7fHJ0dcx2bHC866ThNMOpxKnD6VdnG2ehc53zNRemS5DLEpd2lxdTbaeKp26fesuV5RruutK10/Wjm7ub3K3ZbdTdzD3Ffav7TS6bG8ldwz3vQfTw91jicczjnaebp8LzkOcvXnZeWV77vR5Ps5wmntYwbcjbxFvgvct7YDo+PWX6zukDPsY+Ap96n4e+pr4i3z2+I37Wfpl+B/ye+zv6y/2P+L/hefIW8U4FYAHBAeUBvYEagbMDawMfBJkEpQc1BY0FuwYvDD4VQgwJDVkfcpNvwBfyG/ljM9xnLJrRFcoInRVaG/owzCZMHtYRjobPCN8Qfm+m+UzpzLYIiOBHbIi4H2kZmRf5fRQpKjKqLupRtFN0cXT3LNas5Fn7Z72O8Y+pjLk722q2cnZnrGpsUmxj7Ju4gLiquIF4h/hF8ZcSdBMkCe2J5MTYxD2J43MC52yaM5zkmlSWdGOu5dyiuRfm6c7Lnnc8WTVZkHw4hZgSl7I/5YMgQlAvGE/lp25NHRPyhJuFT0W+oo2iUbG3uEo8kuadVpX2ON07fUP6aIZPRnXGMwlPUit5kRmSuSPzTVZE1t6sz9lx2S05lJyUnKNSDWmWtCvXMLcot09mKyuTDeR55m3KG5OHyvfkI/lz89sVbIVM0aO0Uq5QDhZML6greFsYW3i4SL1IWtQz32b+6vkjC4IWfL2QsFC4sLPYuHhZ8eAiv0W7FiOLUxd3LjFdUrpkeGnw0n3LaMuylv1Q4lhSVfJqedzyjlKD0qWlQyuCVzSVqZTJy26u9Fq5YxVhlWRV72qX1VtWfyoXlV+scKyorviwRrjm4ldOX9V89Xlt2treSrfK7etI66Trbqz3Wb+vSr1qQdXQhvANrRvxjeUbX21K3nShemr1js20zcrNAzVhNe1bzLas2/KhNqP2ep1/XctW/a2rt77ZJtrWv913e/MOgx0VO97vlOy8tSt4V2u9RX31btLugt2PGmIbur/mft24R3dPxZ6Pe6V7B/ZF7+tqdG9s3K+/v7IJbVI2jR5IOnDlm4Bv2pvtmne1cFoqDsJB5cEn36Z8e+NQ6KHOw9zDzd+Zf7f1COtIeSvSOr91rC2jbaA9ob3v6IyjnR1eHUe+t/9+7zHjY3XHNY9XnqCdKD3x+eSCk+OnZKeenU4/PdSZ3Hn3TPyZa11RXb1nQ8+ePxd07ky3X/fJ897nj13wvHD0Ivdi2yW3S609rj1HfnD94UivW2/rZffL7Vc8rnT0Tes70e/Tf/pqwNVz1/jXLl2feb3vxuwbt24m3Ry4Jbr1+Hb27Rd3Cu5M3F16j3iv/L7a/eoH+g/qf7T+sWXAbeD4YMBgz8NZD+8OCYee/pT/04fh0kfMR9UjRiONj50fHxsNGr3yZM6T4aeypxPPyn5W/3nrc6vn3/3i+0vPWPzY8Av5i8+/rnmp83Lvq6mvOscjxx+8znk98ab8rc7bfe+477rfx70fmSj8QP5Q89H6Y8en0E/3Pud8/vwv94Tz+4A5JREAAAAZdEVYdFNvZnR3YXJlAEFkb2JlIEltYWdlUmVhZHlxyWU8AAADJWlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDggNzkuMTY0MDM2LCAyMDE5LzA4LzEzLTAxOjA2OjU3ICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgMjEuMCAoTWFjaW50b3NoKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpGRDEyRTU2MkQyOUYxMUVBQUNBRUZCRTZGNzYwM0E1QiIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpGRDEyRTU2M0QyOUYxMUVBQUNBRUZCRTZGNzYwM0E1QiI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkZEMTJFNTYwRDI5RjExRUFBQ0FFRkJFNkY3NjAzQTVCIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkZEMTJFNTYxRDI5RjExRUFBQ0FFRkJFNkY3NjAzQTVCIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+cxr53gAABDFJREFUeNrs3b+LHGUcB+AZifFHYaVosFHwD7D3ByaFHgb/gJQSRUQLFRULQVRQgojVYRWwSkTLICiIAY2F2Im1aKGiXmcRFPT1u2ROlr3Z3ZvZnZ33vX0e+JBcskPe25v3874zu5erU0oVQJvrPAWAggAUBKAgAAUBKAhAQQAKAlAQgIIAFASAggAUBKAggAEd63PQ3z+eavse8XrJYX2OGULqON46g6/T/ZFnIg9Ebov8Efkqshu5kuF51Wm8x+/6wky0g6Bnge82k+tk5PPIe82vJ6cm3fXGSzY7iJ47gHrJboKD3o+cjbwTeS1ydervboq8HnlxsghHnjReciuIUqQ1HbvJy437Ik9E3o283PL3V6f+/KXIB5GvR3yOSxsvh1nV+/yXc1P3IOoVJ109YkHkfs/kQuRU5O6ZlTjNjOOGyE+Ry5EzI55L88Y768B43YM4evcg6hUnS73hyVa3ZIhj1mky2T5bMtkm/moe9+DI51Jp48UlRtFuj/wyZ0czuwP7OXJrxuOtMhwvCqJov0VOtEyu1LKbuTOyl+l42+QwXga8xGB4k2v0nera3f9qyTX9I5EvjZdcCiJVq78ysMmXOlNLhjhmnXabbfubc7bp+95oHrc78rk0b7xVpuPFDqJoV5pJ9ELk7ZaVefLxueraS4b7jzde3IPoYZU3aY35Vuvnm3//lcjjkU8jvzbX+jvNSlwtuDdhvKw2cVZ8H0SXieR7Mfrb/96GyUuDk7v/e801/P73NqSRn9OVxut9EApCQWzu8yplzP+PNwrCTuKIXWLUGzpm6MuNEsbb5fMqadte2ni3kpuUR2xHaLwoCEBBAAoCUBCAggAUBKAgAAUBoCAABQEoCEBBAAoCUBCAggAUBKAgAAUBoCAABQEoCEBBAAqCw0vGiIJg0cRLxoiCYNYqP5B40zsHPyBHQaAklIOCQEkoh61xzFOQtdTzmDqT8R52/IrkCO8g0sAnPFDoDiJ1WLW6PHbsVTuX8dUdvw5jr8a1Sww7iD7Xv6WdNCXtdHJ7butCn0cG2EHMrhptq28p5XA8cm+mO4nSinfZOcEW3YNYtGqUUA73RM5H9iLfFLSTyP25tZOwg1i4alSZn8CTHcO5yLNLnoeU8QTMfXUuYYxsqCBmSyLncrg58knkoQ6rde6rdM4lwZZfYpT2OX/YoRyc5CiIAa6Lc73+fDrymHKAzV5itN00y+1O9h2Rt6Y+/jdyOXIp8l3k98j3ygHWWxDz7qjn9nLXc5Fbmt9fjLwa+cHOAYYriGUvt+VSEjdGnor8GTkb+dhlBQxbEId9LT6Hkng08k/k4ci3ygGWW9dbres1P3YIO5HTS8oBWGNBdJ3wY67OH1UH3ykJLJqwKXkXLDDcDgJQEICCAFAQgIIAFASgIAAFASgIQEEACgJQEICCALbefwIMAH5H/LT6rRWKAAAAAElFTkSuQmCC") !important;
}

.pswp__counter {
  color: $color-yellow !important;
}

.pswp__button--zoom {
  display: block !important;
}

.pswp__img {
  object-fit: contain;
}

.pswp__button--share {
  background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIzOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOTQuMDE0MyAxNzUuNzI5YzMuMzA1OCAzLjMwNiA4LjY2NTcgMy4zMDYgMTEuOTcxNyAwbDUzLjg3MS01My44NzFjMy4zMDYtMy4zMDYgMy4zMDYtOC42NjYgMC0xMS45NzItMy4zMDUtMy4zMDYtOC42NjUtMy4zMDYtMTEuOTcxIDBMMTAwIDE1Ny43NzJsLTQ3Ljg4NTktNDcuODg2Yy0zLjMwNTktMy4zMDYtOC42NjU3LTMuMzA2LTExLjk3MTUgMC0zLjMwNTggMy4zMDYtMy4zMDU4IDguNjY2IDAgMTEuOTcybDUzLjg3MTcgNTMuODcxek05MS41MzQ5IDguOTA2MlYxNjkuNzQzaDE2LjkzMDFWOC45MDYzSDkxLjUzNDl6IiBmaWxsPSIjRjlERjQxIi8+PHBhdGggZD0iTTEwMCA4LjkwNjNWMTY5Ljc0M005IDE2MS4yNzlWMjI5aDE4MnYtNjcuNzIxIiBzdHJva2U9IiNGOURGNDEiIHN0cm9rZS13aWR0aD0iMTYuOTMwMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9zdmc+") !important;
  background-position: 50% 45% !important;
  background-size: 15px !important;
}

.gallery-fullscreen-ico {
  // display: none;
  position: absolute;
  top: 40px;
  left: 20px;
  display: block;
  width: 50px;
  height: 50px;

  svg {
    display: block;
    width: 230px;
    height: 230px;
    // transform: scale(0.15);
    fill: $color-light;
  }

  @media screen and (min-width: 768px) {
    position: absolute;
    top: 50px;
    left: 30px;
    display: block;
    width: 70px;
    height: 70px;
    transform: scale(1.1);
  }
}

.mobile-video {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 100vh;
  background-color: $color-dark;
  z-index: -100;
  opacity: 0;

  &.show {
    // display: block;
    // z-index: 999;
    opacity: 1;

    .fullscreen-video {
      display: block;
    }
  }

  video {
    display: block;
    width: 100%;
    height: 100%;
  }

  @media screen and (min-width: 768px) {
    display: none;
  }
}

.video-controls {
  &[data-playing="true"] {
    .play {
      display: none;
    }

    .pause {
      display: block;
    }
  }

  &[data-playing="false"] {
    .pause {
      display: none;
    }

    .play {
      display: block;
    }
  }

  a {
    border: 0;
    background: none !important;
  }
}

.download {
  &-form {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 300;
    transform: translate3d(100vw, 0, 0);
    opacity: 0;
    transition: opacity 0.3s ease;

    &.visible {
      opacity: 1;
      transform: translate3d(0, 0, 0);

      .download-form-shape {
        transform: translate3d(0, 0, 0);

        @media screen and (max-width: 768px) {
          -webkit-mask-position: -100vw -40px;
          mask-position: -100vw -40px;
        }
      }
    }

    &-shape.mask-left {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      width: 100vw;
      height: 100vh;
      background: $color-yellow;
      -webkit-mask-position: 0 right;
      mask-position: 0 right;
      transform: translate3d(-200vw, -200px, 0);
      transition: transform 0.3s ease 0.4s;

      @media screen and (max-width: 768px) {
        flex-direction: column;
        padding: 60px 0;
        -webkit-mask-size: 1920px 940px;
        mask-size: 1920px 940px;
        -webkit-mask-position: 100vw 0;
        mask-position: 100vw 0;
        transition: -webkit-mask-position 0.4s ease 0.2s;
      }
    }

    &-col:nth-child(1) {
      margin: -100px 100px 0 0;

      @media screen and (max-width: 768px) {
        margin: 0 0 50px;
        transform: scale(0.7);
      }
    }

    &-col:nth-child(2) {
      margin: -50px 0 0 0;
    }

    &-col,
    form {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      max-width: 580px;

      h5 {
        display: block;
        width: 70%;
        font-family: "Poppins", sans-serif;
        font-style: normal;
        font-weight: 300;
        font-size: 20px;
        line-height: 30px;
        color: $color-dark;
        text-align: left;

        @media screen and (max-width: 768px) {
          font-size: 14px;
          line-height: 24px;
        }

        span {
          display: block;
        }
      }
    }
  }
}

.v-collapse-content {
  max-height: 0;
  transition: max-height 0.3s ease-out;
  overflow: hidden;
  padding: 0;
}

.v-collapse-content-end {
  transition: max-height 0.3s ease-in;
  max-height: 700px;

  @media screen and (max-width: 760px) {
  }
}

.project--epos {
  .epos-logo {
    display: block;
    width: 112px;
    height: 112px;
    z-index: 90;
    position: relative;
    transform: translate3d(0px, 30px, 0) scale(0.6);

    @media screen and (max-width: 760px) {
      transform: translate3d(-10px, -10px, 0) scale(0.4);
    }
  }

  .download-form-shape.mask-left,
  .appointment-form-shape.mask-right,
  .appointment-cta {
    background: $color-orange;
  }

  &.project .project-start-img-shadow,
  &.project .int-ext-shadow {
    background-color: $color-orange;
  }

  &.project .single-img--four {
    background-image: url("~@/assets/content/epos-section3.jpg");
  }

  &.project .project-start-img.epos-second-img {
    background-image: url("~@/assets/content/epos-img2.jpg");
  }

  .apart-item-floors[data-slide="1"] .button:nth-child(1),
  .apart-item-floors[data-slide="2"] .button:nth-child(2) {
    background: $color-orange;
  }

  .apart-item .rooms-list-item .room-ico:after {
    border-color: $color-orange;
  }

  .button {
    border-color: $color-orange;

    &:hover {
      background: $color-orange;
    }
  }

  .scroll-to-top a,
  .button--download {
    background: $color-orange;
  }

  .section-wrapper {
    h2 {
      color: $color-orange;
    }
  }

  .content p {
    white-space: break-spaces;
  }

  @media screen and (max-width: 760px) {
    .apart-item-floors[data-slide="1"] + .apart-item-floorplan img:nth-child(1) {
      z-index: 10;
    }

    .apart-item-floorplan-wrapper img {
      width: 120vw;
      padding: 60px 0 80px;
      transform: scale(1.4);
    }

    .section-wrapper--apartments {
      margin-bottom: -200px;
    }
  }

  @media screen and (min-width: 1024px) {
    .subsection-wrapper--mt200 {
      margin-top: -200px;
    }
  }
}

.section-wrapper {
  @media screen and (min-width: 1024px) {
    &--m0 {
      margin-top: 100px;
    }

    &--projectdetails {
      .project-details-mask {
        -webkit-mask-size: 120vw 110vh;
        mask-size: 120vw 110vh;
      }
    }
  }
  @media screen and (max-height: 850px) and (min-width: 1024px) {
    &:not(.section-wrapper--materials) {
      min-height: 900px;
    }

    &--projectdetails {
      z-index: 90;
    }
  }

  h2.poz-proiecte {
    margin-top: 120px;

    @media screen and (min-width: 1440px) {
      margin-top: 170px;
    }
  }

  &--projectdetails {
    margin-top: -234px;

    h2 {
      margin-top: 146px;
    }
  }

  &--materials {
    display: flex;
    flex-direction: column;
    height: auto !important;
    margin-top: 100px;
    text-align: center;

    .button {
      margin-top: 0 !important;

      &:not(.button--download) {
        svg {
          margin-left: 10px;
        }
      }
    }

    @media screen and (max-width: 760px) {
      // display: none;
      margin-top: 40px !important;
      margin-bottom: 100px;
    }
  }

  &--apartments {
    height: 100%;
    min-height: 100vh;

    @media screen and (max-width: 768px) {
      margin-bottom: -50px;
    }
  }

  &--lastsection {
    @media screen and (max-height: 850px) {
      + .subsection-wrapper {
        margin-top: -270px;
      }
    }

    @media screen and (max-width: 760px) {
      margin-top: 150px !important;

      + .subsection-wrapper {
        margin-top: 0;
      }
    }

    .slick-slider {
      .slick-slide {
        height: 100vh;

        div {
          height: 100%;
        }

        img {
          width: 100%;
          height: 100%;
          max-height: 100%;
          object-fit: cover;

          @media screen and (max-width: 760px) {
            max-width: 100%;
          }
        }
      }
    }
  }
}

.subsection-wrapper {
  &--table {
    display: block;
    width: 100vw;
    max-width: 1020px;
    margin: 40px auto 0;
    padding: 0 5vw;

    .table-scroll {
      width: 100%;
      overflow-y: scroll;
    }

    @media screen and (min-width: 1024px) {
      width: 84vw;
      max-width: 1020px;
      margin: 0 auto;
      padding: 0;
      overflow-y: hidden;

      .table-scroll {
        width: 100%;
        overflow-y: hidden;
      }
    }

    ol {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      width: 860px;
      padding-right: 5vw;

      @media screen and (min-width: 1024px) {
        width: 100%;
        padding-right: 0;
      }

      li {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        text-align: center;

        &.header {
          margin-bottom: 10px;

          span {
            font-weight: 600;
          }
        }

        &.item {
          margin-bottom: 10px;
        }

        &:not(.header) {
          span {
            &:first-child {
              position: relative;

              font-family: "Poppins", sans-serif;
              font-style: normal;
              font-weight: normal;
              font-size: 12px;
              line-height: 18px;
              text-align: center;
              text-transform: uppercase;
              color: $color-dark;

              &:after {
                content: "";
                position: absolute;
                top: -5px;
                left: 24px;
                width: 48px;
                height: 25px;
                border: 2px solid $color-yellow;
                border-radius: 14px;
                transform: rotate(12deg);

                @media screen and (max-width: 768px) {
                  top: -2px;
                  width: 38px;
                  height: 20px;
                  margin-right: 10px;
                  font-size: 10px;
                  line-height: 14px;
                }
              }

              @media screen and (max-width: 768px) {
                font-size: 12px;
                line-height: 18px;
              }
            }
          }
        }

        span {
          width: 10%;
          font-family: "Poppins", sans-serif;
          font-style: normal;
          font-weight: 300;
          font-size: 20px;
          line-height: 30px;
          text-align: center;
          color: $color-dark;

          &:last-child {
            width: 15%;
          }

          @media screen and (max-width: 768px) {
            font-size: 12px;
            line-height: 18px;
          }
        }
      }
    }

    .download-text {
      display: block;
      width: 100%;
      margin: 60px auto 0;
      text-align: center;
    }
  }
}

.project {
  width: 100vw;
  margin: 0 auto;

  .slider2 {
    h3 {
      position: relative;

      .slider2-arrow {
        position: absolute;
        top: 18px;
        width: 70px;
        height: 40px;
        z-index: 100;
        transition: opacity 0.3s ease;

        &:hover {
          cursor: pointer;
        }

        &.disabled {
          opacity: 0.6;
        }

        &::before {
          content: "";
          display: block;
          width: 71px;
          height: 16px;
          background: url("~@/assets/arrow.svg") 0 0 no-repeat transparent;

          @media screen and (max-width: 760px) {
            transform: scale(0.6);
          }
        }
      }

      .slider2-fake-prev {
        left: -50px;

        @media screen and (max-width: 760px) {
          top: 10px;
          left: -40px;
        }
      }

      .slider2-fake-next {
        right: -50px;

        @media screen and (max-width: 760px) {
          top: 10px;
          right: -40px;
        }

        &::before {
          transform: rotate(180deg);

          @media screen and (max-width: 760px) {
            transform: rotate(180deg) scale(0.6);
          }
        }
      }
    }
  }

  .shape {
    &--onlytitle {
      margin: -80px auto -180px;

      + .content {
        transform: translate3d(0, -70px, 0);
      }

      @media screen and (max-width: 760px) {
        margin-top: 60px !important;

        + .content h3 {
          margin-top: 180px;
          margin-bottom: -200px;
        }
      }
    }

    &--carousel {
      margin: -150px auto -180px;

      @media screen and (max-width: 760px) {
        margin: -150px auto -200px;
      }

      + .content {
        transform: translate3d(0, -70px, 0);
      }
    }
  }

  &-hero {
    position: relative;
    display: block;
    width: 100vw;
    height: 100vh;
    margin-top: 0;
    margin-left: 0;
    margin-bottom: -100px;
    background-color: $color-dark;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    -webkit-mask-position: -20vw -20px;
    mask-position: -20vw -20px;
    z-index: 90;
    pointer-events: none;

    video,
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &-details {
    display: block;
    width: 100vw;
    height: 100vh;
    margin-top: 30px;
    margin-left: 0;
    background-size: cover;
    background-position: center center;
    background-repeat: none;
    background-color: $color-light;
    text-align: center;
    transition: opacity 0.3s ease, -webkit-mask-position 1s ease;

    &-shadow {
      display: block;
      width: 100vw;
      height: 100vh;
      background-color: $color-dark;
    }

    &-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      max-width: calc(1200px - 100px);
      height: 100%;
      max-height: 620px;
      margin: 120px auto 0;
    }

    &-block {
      display: flex;
      flex-direction: column;
      align-items: center;

      &--row {
        width: 80%;
        margin-top: 80px;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-end;

        @media screen and (max-width: 760px) {
          width: 100%;
        }
      }

      &-title {
        display: block;
      }

      .v-spacer {
        display: block;
        width: 2px;
        height: 25px;
        margin: 25px auto;
        background: $color-dark;

        @media screen and (max-width: 760px) {
          height: 16px;
          margin: 16px auto;
        }
      }

      @media screen and (max-width: 760px) {
        flex-wrap: wrap;

        &-item {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;
          width: 33%;

          &:last-child {
            margin-right: auto;
          }
        }
      }

      h5,
      h6 {
        display: block;
        font-family: "Poppins", sans-serif;
        font-style: normal;
        color: $color-dark;
        text-align: center;
      }

      h5 {
        font-weight: normal;
        font-size: 18px;
        line-height: 27px;
        letter-spacing: 0.2em;
        text-transform: uppercase;
        color: $color-dark;

        @media screen and (max-width: 760px) {
          font-size: 12px;
        }
      }

      h6 {
        font-weight: 300;
        font-size: 20px;
        line-height: 28px;

        @media screen and (max-width: 760px) {
          margin: 0;
          font-size: 12px;
          line-height: 20px;
        }

        span {
          &:first-child {
            display: inline-block;
          }

          display: block;
        }
      }
    }
  }

  .single-img {
    display: block;
    width: 100vw;
    height: 100vh;
    margin-top: 30px;
    margin-left: 0;
    background-size: cover;
    background-position: center center;
    background-repeat: none;
    background-color: $color-light;
    text-align: center;

    &--four {
      background-image: url("~@/assets/content/section-4.jpg");
    }
  }

  .nearbydetails {
    display: block;
    margin-top: 110px;

    &-list {
      display: block;
      width: 53vw;
      max-width: 640px;
      margin: 0 auto;

      @media screen and (max-width: 760px) {
        width: 80vw;
      }
    }

    &-item {
      position: relative;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      height: 80px;
      margin-bottom: 25px;

      &:last-child {
        margin-bottom: 0;
      }

      .text {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        margin-left: 40px;

        span {
          display: block;
          width: calc(100% - 20px);
          padding: 0 30px 0 20px;
          margin-left: -20px;
          font-family: "Poppins", sans-serif;
          font-style: normal;
          font-weight: 300;
          font-size: 20px;
          text-align: center;
          color: $color-dark;

          @media screen and (max-width: 760px) {
            font-size: 12px;
          }

          &:first-child {
            padding-bottom: 5px;
            margin-bottom: 5px;
            border-bottom: 1px dotted $color-dark;
          }

          &:nth-child(2) {
            font-weight: 600;
          }
        }
      }

      &--foot,
      &--car {
        &::before,
        &::after {
          content: "";
          position: absolute;
          display: block;
          background-size: cover;
          background-position: center center;
          background-repeat: no-repeat;

          @media screen and (max-width: 760px) {
            transform: scale(0.6);
            transform-origin: bottom center;
          }
        }

        &::after {
          top: -18px;
          right: 0;
          width: 43px;
          height: 60px;
          background-image: url("~@/assets/nearby-pin.svg");
        }
      }

      &--foot {
        &::before {
          top: -40px;
          left: 0;
          width: 50px;
          height: 80px;
          background-image: url("~@/assets/nearby-walk.svg");
        }
      }

      &--car {
        &::before {
          top: -10px;
          left: -24px;
          width: 96px;
          height: 50px;
          background-image: url("~@/assets/nearby-car.svg");
        }
      }

      &--final {
        flex-direction: column;
        height: auto;

        &::before {
          content: "";
          position: relative;
          display: block;
          background-size: cover;
          background-position: center center;
          background-repeat: no-repeat;
          width: 160px;
          height: 76px;
          margin-bottom: 10px;
          background-image: url("~@/assets/nearby-locations.svg");
        }

        .text {
          span {
            &:first-child {
              padding-bottom: 0;
              margin-bottom: 0;
              border-bottom: 0;
            }
          }
        }
      }
    }
  }

  .int-ext {
    width: 100vw;
    height: 100vh;
    margin-top: 30px;
    margin-left: 0;
    background-color: $color-lightgrey;
    text-align: center;

    @media screen and (max-width: 760px) {
      height: calc(100% - 30px);
    }

    &-shadow {
      display: block;
      width: 100vw;
      height: 100vh;
      background-color: $color-orange;

      @media screen and (max-width: 760px) {
        height: 100%;
      }

      h2 {
        color: $color-dark;

        span {
          display: block;
        }
      }
    }

    &-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      max-width: 1440px;
      height: 60%;
      margin: 0 auto 0;
    }

    .slick-slider {
      height: 60vh;
      margin-top: 110px;

      @media screen and (max-width: 760px) {
        height: 25vh;
      }
    }
  }

  .materials {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    height: auto;
    width: 35vw;
    max-width: 545px;
    margin: 0 auto;

    @media screen and (max-width: 760px) {
      width: 60vw;
    }

    &-list {
      margin-top: 50px;
    }

    &-item,
    &-text {
      display: block;
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 300;
      font-size: 20px;
      line-height: 30px;
      text-align: center;
      color: $color-dark;

      @media screen and (max-width: 760px) {
        font-size: 12px;
        line-height: 20px;
      }
    }

    &-item {
      line-height: 50px;

      @media screen and (max-width: 760px) {
        line-height: 20px;
      }
    }

    &-text {
      margin-top: 50px;
      margin-bottom: 20px;
    }
  }

  .project-start-img {
    display: block;
    width: 100vw;
    height: 100vh;
    margin-top: 30px;
    margin-left: 0;
    background-image: url("~@/assets/content/section-2.jpg");
    background-size: cover;
    background-position: 0 45%;
    background-repeat: no-repeat;
    // background-attachment: fixed;
    background-color: $color-light;
    text-align: center;

    @media screen and (max-width: 768px) {
      background-size: cover;
      background-position: center center;
    }

    &-shadow {
      display: block;
      width: 100vw;
      height: 100vh;
      background-color: $color-yellow;

      h2 {
        color: $color-dark;
      }
    }

    &-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      max-width: 1440px;
      height: 60%;
      margin: 0 auto 0;
    }
  }

  .single-img {
    display: block;
    width: 100vw;
    height: 100vh;
    margin-top: 30px;
    margin-left: 0;
    background-size: cover;
    background-position: center center;
    background-repeat: none;
    background-color: $color-light;
    text-align: center;

    &--three {
      background-image: url("~@/assets/content/section-3.jpg");
    }

    &--four {
      background-image: url("~@/assets/content/section-4.jpg");
    }

    &--five {
      background-image: url("~@/assets/content/section-5.jpg");
    }
  }

  &-map {
    position: relative;
    display: block;
    width: 100vw;
    height: 100vh;
    margin-top: -75vh;
    z-index: 90;

    @media screen and (max-height: 850px) {
      margin-top: -90vh;
    }

    @media screen and (max-width: 760px) {
      margin-top: -75vh;
    }
  }
}

.apart {
  &-details {
    position: relative;
    display: block;
    width: 100%;
    margin-top: 40px;
    z-index: 79;

    .slick-slider {
      margin-top: 150px;

      .slick-prev,
      .slick-next {
        top: 14px;

        @media screen and (max-width: 768px) {
          top: 34px;
        }
      }

      .slick-prev {
        left: calc(40% - 180px);

        @media screen and (max-width: 768px) {
          left: 0;
        }
      }

      .slick-next {
        right: calc(40% - 180px);

        @media screen and (max-width: 768px) {
          right: 0;
        }
      }
    }
  }

  &-item {
    &-headline {
      h4 {
        display: block;
        font-family: "Poppins", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        line-height: 27px;
        text-align: center;
        letter-spacing: 0.2em;
        text-transform: uppercase;
        color: $color-dark;
        text-transform: uppercase;

        @media screen and (max-width: 768px) {
          font-size: 14px;
          line-height: 20px;
        }
      }
    }

    &-subheadline {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
      width: 50vw;
      max-width: 600px;
      margin: 50px auto 0;

      @media screen and (max-width: 768px) {
        flex-direction: column;
        align-items: center;
      }

      h5 {
        display: block;
        font-family: "Poppins", sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 30px;
        align-items: center;
        text-align: center;
        color: $color-dark;

        span {
          display: block;
          font-weight: 300;
        }

        @media screen and (max-width: 768px) {
          font-size: 14px;
          line-height: 20px;
        }
      }
    }

    &-floors {
      margin-top: -20px;
      text-align: center;

      @media screen and (max-width: 768px) {
        margin-top: 0;
      }

      &[data-slide="1"] {
        .button:first-child {
          background-color: $color-yellow;
        }
      }

      &[data-slide="2"] {
        .button:nth-child(2) {
          background-color: $color-yellow;
        }
      }

      &[data-slide="3"] {
        .button:nth-child(3) {
          background-color: $color-yellow;
        }
      }

      .button {
        margin-right: 14px;
        outline: none;

        &:last-child {
          margin-right: 0;
        }
      }
    }

    &-floorplan {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: flex-start;
      width: 90vw;
      height: auto;
      margin: 90px auto 90px;

      &-left {
        width: 28vw;
        max-width: 400px;
      }

      &-right {
        display: block;
        width: 700px;
        height: 100%;
        overflow: hidden;
      }

      &-wrapper {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        width: 100%;
        transition: transform 0.3s ease;

        img {
          width: 100%;
          height: auto;
          object-fit: contain;
        }
      }

      @media screen and (max-width: 768px) {
        flex-direction: column;
        width: 100vw;
        font-size: 14px;
        line-height: 20px;

        &-left {
          order: 2;
          width: 65vw;
          margin: 40px auto 0;
        }

        &-right {
          order: 1;
          width: 100%;
        }

        &-wrapper {
          img {
            max-width: 100%;
          }
        }
      }
    }

    .rooms-list {
      display: block;

      &-item {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        margin-bottom: 20px;

        &:last-child {
          .room-ico {
            opacity: 0;
            visibility: hidden;
          }
        }

        &:last-child {
          margin-bottom: 0;
        }

        .room {
          &-ico {
            position: relative;
            width: 48px;
            height: 25px;
            margin-right: 18px;
            font-family: "Poppins", sans-serif;
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 18px;
            text-align: center;
            text-transform: uppercase;
            color: $color-dark;

            &:after {
              content: "";
              position: absolute;
              top: -5px;
              left: -2px;
              width: 100%;
              height: 100%;
              border: 2px solid $color-yellow;
              border-radius: 14px;
              transform: rotate(12deg);
            }

            @media screen and (max-width: 768px) {
              width: 38px;
              height: 20px;
              margin-right: 10px;
              font-size: 10px;
              line-height: 14px;
            }
          }

          &-title,
          &-sqm {
            display: block;
            font-family: "Poppins", sans-serif;
            font-style: normal;
            font-weight: 300;
            font-size: 20px;
            line-height: 30px;
            color: $color-dark;

            @media screen and (max-width: 768px) {
              font-size: 12px;
              line-height: 18px;
            }
          }

          &-sqm {
            width: 20%;
            text-align: right;
          }

          &-title {
            width: calc(80% - 48px);
            margin-right: 18px;
            text-align: left;

            @media screen and (max-width: 768px) {
              margin-right: 8px;
            }
          }
        }
      }
    }

    &-pos {
      display: block;
      width: 90vw;
      height: 62px;
      max-height: 732px;
      margin: 0 auto;
      text-align: center;
      overflow: hidden;

      .button {
        min-width: 240px;
        margin-top: 0;

        svg {
          margin-left: 10px;
        }
      }

      &.visible {
        height: 572px;
      }

      img {
        display: block;
        margin-top: 90px;
        width: 100%;
        max-height: 400px !important;
        object-fit: contain !important;
        pointer-events: none;
      }

      @media screen and (max-width: 768px) {
        height: 42px;
        margin-right: 8px;

        &.visible {
          height: 460px;
        }

        img {
          max-height: 290px !important;
          object-fit: contain;
        }
      }
    }
  }
}

@media screen and (max-width: 760px) {
  .project {
    &-hero {
      margin-bottom: 0;
      background-image: url("~@/assets/content/hero-m.gif");
      background-size: cover;
      background-position: center center;
      background-repeat: none;

      video {
        display: none;
      }

      &.mask-right {
        -webkit-mask-position: right -20vh;
        mask-position: right -20vh;
      }

      &-content {
        h3,
        h2 {
          width: 80vw;
        }

        h3 {
          font-family: "Poppins", sans-serif;
          font-style: normal;
          font-weight: 600;
          font-size: 10px;
          line-height: 15px;
          letter-spacing: 0.2em;
        }

        h2 {
          font-family: "gopherbold";
          font-style: normal;
          font-size: 35px;
          line-height: 35px;
          text-align: center;
        }

        a {
          padding: 13px 11px;
          font-size: 10px;
          line-height: 12px;
          border-radius: 44px;
        }
      }
    }

    .section-wrapper {
      height: calc(100vh - 65px);
      margin-top: -48px;
      z-index: 90;

      > div:not(.social-footer) + div {
        // top: -100px;
        top: 0;
      }

      &--m0 {
        margin-top: 120px;
      }

      &--projects {
        height: 960px;

        .button--map {
          display: none;
        }
      }

      &--footer {
        height: 940px;
      }

      @media screen and (max-width: 1024px) {
        &--int-ext {
          height: 55vh;
        }
      }

      &.mt190 {
        margin-top: -90px;
      }

      &.mt120 {
        margin-top: -100px;
      }

      h2 {
        margin: 50px auto 0;
        font-size: 12px;
        line-height: 18px;
      }

      .single-img {
        height: calc(100vh - 65px);
      }
    }

    .our-projects {
      height: 150vh;

      &.mask-right {
        -webkit-mask-size: 1920px 1100px;
        mask-size: 1920px 1100px;
      }

      &-wrapper {
        flex-direction: column;
        height: auto;
        padding-top: 90px;

        @media screen and (max-width: 760px) {
          padding-top: 0;
        }
      }

      &-block {
        margin-top: -30px;

        &:nth-child(2) {
          margin-top: -30px;

          .our-projects-block-title {
            margin-top: -80px;
          }
        }

        &:nth-child(3) {
          margin-top: -30px;

          .our-projects-block-title {
            margin-top: -70px;
          }
        }

        &-title {
          margin-top: -60px;
          padding: 10px 30px;

          span {
            font-size: 10px;
          }
        }

        h4 {
          font-size: 20px;
        }

        svg {
          transform: scale(0.4);
        }
      }
    }

    .about-us {
      background-position: center 0;

      &-shadow {
        height: 89vh;
      }

      &-content {
        margin-top: 200px;

        &.mt180 {
          margin-top: 180px;
        }
      }
    }

    .subsection-wrapper {
      margin-bottom: 60px;

      .shape {
        width: 73vw;
        height: 120px;
        margin-top: 0;
        border-radius: 64px;

        &--withtitle {
          margin-top: 40px;
        }

        &--notitle {
          margin-top: 170px;
        }

        &.short {
          margin: -20px auto -150px;
        }
      }

      h3 {
        width: 66vw;
        font-size: 24px;
        line-height: 30px;
      }

      p {
        width: 66vw;
        max-width: 66vw;
        font-size: 12px;
        line-height: 18px;
      }
    }

    .footer {
      height: 1000px;
    }

    .footer-wrapper {
      flex-direction: column;
      margin-top: 120px;

      &-text {
        width: 80vw;
        margin: 0 auto;

        h4 {
          width: 70%;
          margin: 0 auto;
          font-size: 23px;
          line-height: 29px;
          text-align: center;
        }

        p {
          font-size: 12px;
          line-height: 18px;
          text-align: justify;
        }
      }

      &-form {
        width: 80vw;
        margin: 0 auto;

        h5 {
          display: block;
          width: 100%;
          font-size: 15px;
          text-align: center;
        }
      }
    }

    .social-footer {
      margin: 20px auto;
    }
  }
}
</style>
